// Extra strings for TurnosIA module and sidebar items not covered in en.js
const messages = {
  en: {
    translations: {
      support: {
        "menu": "Support",
        "title": "Support",
        "subtitle": "Tell us your question or complaint and we'll reply right here, on this screen.",
        "company": "Company",
        "yourQuery": "Your request",
        "placeholder": "Tell us what you need or what happened, in as much detail as possible…",
        "counter": "{{count}} / {{max}}",
        "privacy": "Do not paste messages from your customers or patients: the request text is processed by an AI provider.",
        "ticketLabel": "Ticket ID (optional)",
        "ticketPrefilled": "Ticket #{{id}}",
        "contactLabel": "Contact",
        "connectionLabel": "Connection (optional)",
        "connectionNone": "None",
        "removeTicket": "Remove ticket",
        "attach": "Attach screenshot",
        "pasteImage": "Paste image",
        "pasteHint": "You can also paste an image with Ctrl+V (Cmd+V on Mac).",
        "pasteUnsupported": "Your browser does not allow pasting images with the button. Use Ctrl+V (Cmd+V) or attach the screenshot.",
        "newReply": "New reply",
        "pasteDenied": "Clipboard access was not granted. Try Ctrl+V (Cmd+V) or attach the screenshot.",
        "pasteNoImage": "There is no image in the clipboard.",
        "imagesCount": "{{count}} of {{max}} images",
        "removeImage": "Remove image",
        "openImage": "Enlarge image",
        "closeImage": "Close",
        "errType": "Only PNG, JPG or WebP images are accepted.",
        "errSize": "Each image can be up to 5 MB.",
        "errCount": "You can attach up to 3 images.",
        "send": "Send",
        "sending": "Sending…",
        "sentOk": "Request sent. Number #{{id}}.",
        "legend": "The answer appears on this screen; a red number on the Support menu tells you there is a new reply.",
        "myQueries": "Your requests",
        "empty": "You haven't sent any requests yet.",
        "loadMore": "Show more",
        "loadError": "We couldn't load your requests.",
        "refresh": "Refresh",
        "loading": "Loading…",
        "bubbleMine": "Your request",
        "bubbleOurs": "Our answer",
        "bubbleClarify": "We need more information",
        "replyPlaceholder": "Write your reply…",
        "replySend": "Reply",
        "replyHelp": "We need something more to help you. Reply in this same thread.",
        "closedNote": "This request is closed.",
        "copyId": "Copy number",
        "idCopied": "ID copied",
        "idCopyFailed": "Could not copy the ID.",
        "buttonLabel": "Support",
        "buttonTooltip": "Contact Support about this ticket (copies the ID)",
        "draftKept": "Your draft is kept while you navigate.",
        "ticketNote": "Ticket #{{id}}",
        "status": {
          "recibida": "Received",
          "necesita_datos": "More information needed",
          "en_revision": "Under review",
          "borrador_listo": "Under review",
          "respondida": "Answered",
          "cerrada": "Closed",
          "borde": "Under review",
          "pasada_checklist": "Under review",
          "resuelta_checklist": "Answered"
        }
      },
      crmBoard: {
        cardActions: "Actions",
        openInChat: "Open in chat",
        transfer: "Transfer",
        transferClosedHint: "Closed conversation: reopen it first to transfer it.",
        noTicket: "This contact has no conversation.",
        entryBadge: "Entry",
        entryTooltip: "Entry stage: contacts with a conversation that don't have a stage yet show up here.",
        noEntryText: "Contacts without a stage don't show up in the Funnel. Choose an entry stage to see them.",
        noEntryTextUser: "Contacts without a stage don't show up in the Funnel. An administrator can choose an entry stage in Contact States.",
        noEntryAction: "Choose entry stage",
        title: "Funnel",
        noState: "No state",
        inactiveTooltip: "Disabled state: shows the contacts that still have it, but contacts can't be dropped here.",
        inactiveBadge: "Disabled",
        loadMore: "Load more",
        emptyColumn: "No contacts",
        unassigned: "Unassigned",
        searchPlaceholder: "Search contact…",
        dateFrom: "Last contact from",
        dateTo: "To",
        clearFilters: "Clear filters",
        refresh: "Refresh",
        loadError: "Could not load the Funnel.",
        moveError: "Could not change the state. The contact went back to its column.",
        closedAuto: "The contact's chat was closed (automatic close).",
        noMessages: "No messages",
        openTickets: "Open chats: {{count}}",
        prefixAdvisor: "Agent: ",
        prefixAi: "AI: ",
        prefixSystem: "System: ",
        timeNow: "now",
        timeMinutes: "{{count}} min",
        timeHours: "{{count}} h",
        timeDays: "{{count}} d",
        openChatError: "Could not open the chat.",
        disabledTitle: "The Funnel is not enabled",
        disabledText: "An administrator can enable it in Contact States.",
        needsStatesTitle: "There are no active contact states",
        needsStatesText: "Enable at least one state in Contact States to use the Funnel.",
        goToStates: "Go to Contact States",
        historyTitle: "State history",
        historyEmpty: "No changes recorded yet.",
        historyApi: "API",
        historyBoard: "Funnel",
        historyUnknownUser: "System",
        historyLoadError: "Could not load the history.",
        historyMore: "Load more",
      },
      contactStateModal: {
        title: "Change contact state",
        lostTitle: "Why was it lost?",
        otherReason: "Other reason",
        otherReasonLabel: "Specify reason",
        cancel: "Cancel",
        back: "Back",
        confirm: "Confirm",
        noState: "No state",
        chipTooltip: "Stage in the sales process",
      },
      // feat_315 — formato fecha/hora tipo WhatsApp (fmtSmartTimestamp)
      smartTimestamp: {
        yesterday: "Yesterday",
        today: "Today",
      },
      loginPage: {
        sections: {
          waia: {
            nav: "WAIA",
            title: "Stop letting WhatsApp support eat your whole day",
            chip1: "Shared inbox",
            chip2: "AI that replies",
            chip3: "Multi-company",
          },
          turnosia: {
            nav: "TurnosIA",
            title: "Appointments over WhatsApp, no no-shows",
            chip1: "AI waiting list",
            chip2: "Reminders",
            chip3: "Waiting-room screen",
          },
          integraciones: {
            nav: "Integrations",
            title: "Connect your tools",
            chip1: "Google Sheets",
            chip2: "CRMs",
            chip3: "Webhooks · n8n",
            chip4: "Own API",
          },
        },
        metaBadge: "Verified technology provider — Meta",
      },
      turnosChat: {
        iaPaused: "AI paused",
        keepAttending: "Keep attending",
        closeDialogTitle: "Close appointments chat",
        closeDialogBody: "Do you want to return the conversation to the AI or keep it under human attention?",
        returnToIa: "Yes, return to AI",
        keepHuman: "Keep under human attention",
        continueAttending: "Keep attending",
        iaResumed: "The AI resumed the conversation",
        badgeActive: "TurnosIA",
        sessionError: "Could not manage the appointments session",
      },
      floatingChat: {
        moreActions: "More actions",
        openInChat: "Open in chat",
        transfer: "Transfer",
        transferredTo: "Chat transferred to {{name}}.",
        notOpenPending: "This chat is waiting. Take it to be able to write.",
        notOpenClosed: "This chat is closed. Reopen it to be able to write.",
        sendTemplate: "Send template",
        hideTemplate: "Cancel",
        otherOpenTicket:
          "There is already an open conversation with this contact. Open it from Chats to write to them; the template was not sent.",
        resize: "Resize",
        minimize: "Minimize",
        close: "Close",
        openFloating: "Open in floating window",
        errorOpening: "Could not open chat",
        loadError: "We couldn't load this conversation.",
        loadErrorDenied: "You don't have permission to open this chat (the ticket isn't in any of your queues).",
        retry: "Retry",
        loading: "Loading conversation…",
        via: "via",
        lineNotAllowed:
          "Could not open the chat on that line (it does not belong to your company or does not exist).",
      },
      templateOverrides: {
        loading: "Loading templates…",
        sectionTitle: "Meta template per message (outside the 24 h window)",
        qrLine: "The TurnosIA line is QR (free text): it does not use Meta templates.",
        noLine: "This company has no Meta TurnosIA line configured.",
        intro:
          "Choose which approved Meta template each message uses outside the 24 h window. Only variable-compatible ones are offered. No choice = the convention template.",
        vars: "variables",
        useDefault: "Use the convention one",
        incompatible: "incompatible",
        backToDefault: "Back to default",
        mapped: "Mapped to",
        usingConvention: "Uses the convention",
        marketingWarning:
          "This is a MARKETING template on a transactional message: Meta may block it or the customer may flag it as spam.",
        noneCompatible:
          "There are no compatible approved templates (same variable count) for this message.",
        saveError: "Could not save the mapping.",
        useLabel: "Outside 24 h, use:",
        metaSubsectionTitle: "Outside 24 h (Meta template)",
        notCreated: "not created/approved in Meta yet",
        noPreview: "No preview available for this template.",
        noMeta: "This message always goes as free text within the conversation (no Meta template).",
        stApproved: "Approved",
        stPending: "In review",
        stRejected: "Rejected",
        showExample: "Show with example data",
        hideExample: "Show with variable names",
        reminderFuture: "In advance (more than 12 h before)",
        reminderToday: "On the appointment day (12 h or less)",
      },
      panel: {
        title: "Overview",
        refresh: "Refresh",
        summary: {
          messages2h: "Messages 2h",
          openTickets: "Open tickets",
          activeCompanies: "Active companies",
          usersOnline: "Users online",
          totalCompanies: "Total companies",
        },
        system: {
          disk: "Disk",
          mem: "Memory",
          load: "Load",
          public: "Media",
          uptime: "Uptime",
          error: "measure error",
        },
        companies: "Companies",
        search: "Search by name, slug, ID, user, email or notes…",
        filterAll: "All",
        col: {
          id: "ID",
          name: "Name",
          status: "Status",
          usersOnline: "Online",
          whatsapp: "WA",
          messages7d: "Msg 7d",
          actions: "Actions",
        },
        actions: {
          edit: "Edit",
          impersonate: "View as",
          clear: "Clear data",
          create: "Create company",
          advanced: "Advanced settings",
          users: "Manage users",
          viewAsAdmin: "View as admin",
          viewAsUser: "View as specific user",
        },
        notesLabel: "Notes (superadmin only)",
        editTitle: "Edit company",
        createTitle: "Create company",
        adminSection: "Initial admin user (optional)",
        selfRegistration: "Allow company registration (public signup)",
        online: "Online",
      },
      operationStatus: {
        active: "Active",
        paused: "Paused",
        blocked: "Blocked",
        waiting_meta: "Waiting Meta",
        demo: "Demo",
        trial: "Trial",
      },
      aiAssistantStats: {
        menu: "AI Stats",
        tooltips: {
          horasAhorradas:
            "An estimate of the support time the AI saved the team. It is calculated from the number of conversations and an estimated handling time per conversation. It is an estimate, and we will keep refining it.",
          cobertura:
            "Percentage of replies the AI gave outside human support hours —at night or on weekends—, when a person would not have answered at that moment. Measured over conversations that were answered.",
          reclamosATiempo:
            "Number of complaints the AI detected and flagged the same day, in time for the team to act.",
          iaVsHumano:
            "Messages answered by the AI versus those answered by a person, in the period.",
          tasaRespuesta:
            "Of the conversations the AI started, what percentage the customer replied to. It is replies divided by conversations sent.",
          tasaAccion:
            "Of the customers who replied, what percentage the AI brought to a conclusion —satisfied or complaint—. Measured over those who replied.",
          satisfechos:
            "Customers who were satisfied. The first percentage is over all conversations sent; the second, only over those who replied.",
          reclamos:
            "Customers who raised a complaint or dissatisfaction. The first percentage is over the total sent; the second, only over those who replied.",
          sinRespuesta:
            "Customers who did not answer the survey. The first percentage is over the total sent; the second, over those who replied.",
          embudo:
            "The conversations' journey: how many were sent, how many replied and how many reached a conclusion.",
          primeraRespuesta:
            "Average time the customer took to reply to the AI's first message.",
          atencionHumana:
            "Indicates whether a team member stepped into the chat within support hours.",
          objetoReclamo:
            "Main topic of each complaint, identified by the AI when closing the conversation.",
          etiquetas:
            "Interest tags —for example, interested in buying— that the AI marked on the conversations.",
          breakdowns:
            "The same results split by branch and by survey type, for comparison.",
          canalVenta:
            "Sales channel: P = Conventional, PA = Savings plan. This data is available on sales from 06/24/2026 onward.",
        },
        heroTitle: "AI assistant statistics",
        detailTitle: "Assistant detail",
        backToHero: "Back to summary",
        disabled: "The statistics module is not enabled for your company.",
        modeTV: "TV Mode",
        exitTV: "Exit",
        clientSummary: "Client summary",
        selectAssistant: "View assistant",
        breakdowns: {
          title: "Breakdown by segment",
          bySucursal: "By branch",
          byTipoEncuesta: "By survey type",
          bySubtipo: "By subtype",
        },
        canalVenta: {
          title: "Sales channel",
          filterLabel: "Sales channel",
          all: "All",
          convencional: "Conventional",
          planAhorro: "Savings plan",
          sinDato: "No data",
          availabilityNote:
            "Data available from 06/24/2026 · earlier sales not recorded.",
          tooltip:
            "Sales channel: P = Conventional, PA = Savings plan. Available on sales from 06/24/2026.",
        },
        cards: {
          horasAhorradas: "Hours saved",
          horasAhorradasCaption: "{{name}} saved you {{n}} hours",
          cobertura: "24/7 coverage",
          coberturaCaption: "{{pct}} handled after hours, 0 waiting for a human",
          reclamos: "Complaints on time",
          reclamosCaption: "{{n}} complaints caught on time",
          iaVsHumano: "AI vs human",
          iaVsHumanoCaption: "{{ia}} AI / {{hum}} human",
        },
        table: {
          asistente: "Assistant",
          tipo: "Type",
          enviados: "Sent",
          respondieron: "Replied",
          tasaResp: "Reply rate",
          reclamos: "Complaints",
        },
        filters: {
          dateRange: "Date range",
          from: "From",
          to: "To",
          sucursal: "Branch",
          tipoEncuesta: "Survey type",
          all: "All",
          service: "Service",
          venta: "Sale",
        },
        funnel: {
          title: "Funnel",
          enviados: "Sent",
          respondieron: "Replied",
          clasificados: "Classified",
        },
        kpis: {
          title: "Indicators",
          satisfechos: "Satisfied",
          reclamos: "Complaints",
          sinRespuesta: "No reply",
          sobreTotal: "of total",
          sobreRespondieron: "of replied",
          tasaRespuesta: "Reply rate",
          tasaAccion: "Sofía action rate",
          objetoReclamo: "Complaint subject",
          tagsTrackeados: "Tracked tags",
          interesadoComprar: "Interested in buying",
          primeraRespuesta: "Customer 1st reply",
          atencionHumana: "Human attention in hours",
          atendidoHorario: "Handled within hours",
          atendidoCierre: "Handled at end of day",
          si: "Yes",
          no: "No",
        },
        insights: {
          title: "Recommendations",
          recommendations: "{{count}} recommendation",
          recommendations_plural: "{{count}} recommendations",
          severityWarning: "Warning",
          severityInfo: "Info",
          severitySuccess: "Win",
          severityOportunidad: "Opportunity",
          severitySofiaEnAccion: "Sofía in action",
          ventana_muerta:
            "Sofía is on around the clock. {{count}} surveys went out after {{horaLimiteDisparo}}h; since the team alert only fires {{timeoutHours}}h later, the few who don't reply don't make it to a person before closing. Firing them earlier recovers that margin.",
          disparo_tardio:
            "Sofía fires the surveys around {{medianaHoraDisparo}}h. Sending earlier lets more non-responding customers reach the team before closing.",
          timeout_absorbe:
            "{{pct}} didn't reply within the window. Sofía stayed available anyway for whenever they want to pick it back up.",
          reclamo_sin_atencion:
            "Sofía detected and flagged {{count}} complaints the same day. To close the loop, a person should pick them up before closing.",
          buena_cobertura:
            "Sofía answered {{fueraHorarioCount}} surveys after hours — attention a human wouldn't have given.",
          generic: "Recommendation available.",
        },
        units: {
          horas: "h",
          seg: "s",
          min: "min",
        },
        empty: {
          noData: "No data yet for this period.",
          noAssistants: "This client has no assistants with statistics yet.",
          noObjeto: "No complaint subjects in this period.",
          noTags: "No tracked tags in this period.",
          noPeriod: "No data for this period.",
        },
      },
      chatInput: {
        systemChannelReadOnly: "Automated alerts channel. Messages cannot be sent.",
      },
      matchpropBanner: {
        text: "You have {{count}} unreviewed property match(es) in MatchProp",
        goToChat: "Go to the Property Alerts chat",
      },
      chatHighlight: {
        needsAttention: "Needs attention",
        matchprop: "Property match",
      },
      matchpropCard: {
        title: "Match detected",
        test: "TEST",
        levelExact: "EXACT",
        levelSimilar: "SIMILAR",
        requestLabel: "Request",
        inGroup: "in group {{group}}",
        operacion: "Operation",
        tipo: "Type",
        dorms: "Bd.",
        zonas: "Areas",
        precioMax: "Max price",
        matchesHeader: "Matches",
        priceOnRequest: "price on request",
        viewListing: "View listing",
        contactAuthor: "Message {{name}}",
        contactAuthorShort: "Message the colleague",
        viewInGroup: "View request in group",
        contactOk: "Colleague chat opened",
        groupNotFound: "Group chat not found",
        actionError: "Could not complete the action",
      },
      turnosIA: {
        setupHealth: {
          titulo: "This company has not finished setting up TurnosIA",
          token: {
            queFalta: "The company has no WAIA token configured.",
            comoResolver: "It is copied automatically when the TurnosIA module is enabled from WAIA: turn that switch off and on again.",
          },
          rubro: {
            queFalta: "The company has no industry template applied.",
            comoResolver: "Pick the industry template in the TurnosIA superadmin panel: it seeds specialties, fields and the business vocabulary.",
          },
          especialidades: {
            queFalta: "There are no specialties loaded, so no professional can be created.",
            comoResolver: "Apply an industry template (it seeds them) or add them by hand from Services.",
          },
        },
        bandeja: {
          tituloTarjeta: "Cases to resolve",
          tituloInbox: "Case inbox",
          sinCasos: "No pending cases. The AI is handling everything on its own. 🎉",
          sinNombre: "No name",
          enCurso: "In progress",
          tomar: "Take",
          resuelto: "Resolved",
          resolverTurno: "Book it",
          asignarTurno: "Assign {{appointment}}",
          verTurno: "View {{appointment}}",
          notasTurno: "{{appointment_c}} notes",
          abrirChat: "Open chat",
          sinTelefonoValido: "No valid phone number",
          chatNoEncontrado: "No open chat found for this contact.",
          tomadoOk: "Case taken",
          resueltoOk: "Case resolved",
          errorGuardar: "Could not update the case",
          turnoCreadoHint: "Done, it's booked. If the case is settled, mark it as Resolved.",
          turnoRelacionado: "Related {{appointment}}",
          motivo: "Reason",
          horaCaso: "Time",
          transcriptNoDisponible: "The conversation detail is not available in this view.",
          conversacion: "Conversation",
          reason: {
            fuera_de_alcance: "Out of scope",
            pidio_humano: "Asked for a human",
            sin_disponibilidad: "No availability",
            reclamo: "Complaint",
            urgente: "Urgent",
            fallo_tecnico: "Technical failure",
            otro: "Other",
          },
        },
        vocabDefaults: {
          patient: "patient", patientPlural: "patients",
          patientName: "Patient name", patientPhone: "Phone",
          professional: "professional", professionalPlural: "professionals",
          appointment: "appointment", appointmentPlural: "appointments",
          specialty: "specialty", specialtyPlural: "specialties",
          service: "service", servicePlural: "services",
          waitingRoom: "waiting room", waitingRoomPlural: "waiting rooms",
          cobertura: "coverage", coberturaPlural: "coverages",
          scheduler: "scheduler", schedulerPlural: "schedulers",
          room: "room", roomPlural: "rooms",
          patientGen: "m", professionalGen: "m", appointmentGen: "m", specialtyGen: "m",
          serviceGen: "m", waitingRoomGen: "m", coberturaGen: "m", schedulerGen: "m", roomGen: "m",
        },
        metricas: {
          widget: {
            verMas: "See more",
            verMasTooltip: "Open the full metrics page",
            tooltip: "What the assistant did for your business",
            vacio: "Here you'll see what the assistant does for you: {{appointmentPlural}} it books on its own and {{appointmentPlural}} it recovers when someone cancels. No activity to show yet.",
            mes: "Month to date",
            d30: "Last 30 days",
            agendadosSolos: "{{appointmentPlural}} booked on their own",
            seAgendaronSolos: "booked on their own",
            de: "of",
            recuperados: "recovered",
            previos: "Previous 30 days: {{n}}",
          },
          filtroProfesional: "{{professional_c}}",
          filtroServicio: "{{service_c}}",
          sinFiltro: "No filter",
          errorCarga: "Could not load the metrics. Try again in a moment.",
          d7: "7 days", d30: "30 days", d90: "90 days", m12: "12 months",
          aTitulo: "What the assistant did for your business",
          aSub: "The assistant's return over the selected period.",
          aVacio: "Here you'll see what the assistant does for you: {{appointmentPlural}} it books on its own, {{appointmentPlural}} it recovers when someone cancels, and the questions it hands to a person. No activity to show yet.",
          aAgendadosSolos: "{{appointmentPlural_c}} booked on its own",
          aRecuperados: "recovered by rebalancing",
          aDerivados: "handed to a person",
          aCreadosTotal: "{{appointmentPlural}} in total",
          aCreadosRecuperados: "recovered",
          aCreadosIA: "booked by the AI",
          aCreadosMano: "entered by hand",
          aSerieRecuperados: "Recovered",
          aNotaDesde: "What the assistant booked is counted from {{fecha}} (when it started recording its origin). Before that date nothing is shown, so zeros don't mislead.",
          bTitulo: "Schedule health",
          bSub: "How the period went.",
          bVacio: "Once there's activity in the period you'll see here how many were completed, how many were cancelled (and how far ahead) and how many were no-shows.",
          bCompletados: "Completed",
          bCancelados: "Cancelled",
          bNoShow: "No-shows",
          bAnticipacion: "Cancellation notice",
          bAnticipacionSub: "average · {{n}} cancellation(s)",
          bAnticipacionVacio: "no dated cancellations",
          bTasaConfirmacion: "Confirmation rate",
          bTasaSub: "{{r}}/{{s}} replied · {{elPatient}}, not the panel",
          bTasaVacio: "no confirmation reminders in the period",
          cTitulo: "Service quality",
          cSub: "Punctuality, wait and real duration. Calculated when the team marks arrival / call / start / end.",
          cVacio: "Once the team uses the attendance flow (marking that they arrived, that they were called and when it started and ended) you'll see punctuality, wait time and real duration here.",
          cPuntualidad: "Punctuality (average start delay)",
          cPuntualidadSub: "{{pct}}% on time · {{n}} attended",
          cEspera: "Average wait",
          cEsperaSub: "{{n}} with an arrival time",
          cEsperaVacio: "no arrival recorded",
          cDuracion: "Real duration (average)",
          cDuracionSub: "estimated {{est}} min · {{n}} attended",
          cSinDatos: "no data yet",
          dTitulo: "Assistant activity",
          dSub: "Hand-offs to a person and reminders sent.",
          dVacio: "Here you'll see why the assistant handed questions to a person and how many reminders it sent. No activity in the period yet.",
          dMotivos: "Hand-off reasons ({{n}})",
          dSinDerivaciones: "No hand-offs in the period.",
          dRecordatorios: "Reminders sent ({{s}} of {{t}})",
          dSinRecordatorios: "No reminders in the period.",
          dDerivaciones: "Hand-offs",
          dEnviados: "Sent",
          dFallidos: "Failed",
          pie: "Period {{from}} → {{to}}. The numbers come from the system and are verifiable; metrics that can't be computed reliably today are not shown.",
          rConfirmacionReserva: "Booking confirmation",
          rRecordatorio: "Reminder",
          rPedidoConfirmacion: "Confirmation request",
          rOfertaLiberado: "Freed slot offer",
          rOfertaListaEspera: "Waiting list offer",
        },
        menu: {
          metricas: "Metrics",
          agenda: "Schedule",
          profesionales: "Professionals",
          agendadores: "Secretaries",
          servicios: "Services",
          disponibilidad: "Availability",
          precios: "Prices",
          listaEspera: "Waiting List",
          recordatorios: "Reminders",
          ajustes: "Settings",
          miAgenda: "My Schedule",
        },
        calendar: {
          title: "Calendar",
          day: "Day",
          week: "Week",
          month: "Month",
          today: "Today",
          prev: "Previous",
          next: "Next",
          noEvents: "No {{appointmentPlural}} in this range.",
          colorByProfessional: "Color by {{professional}}",
          colorByStatus: "Color by status",
          allProfessionals: "No filter",
          allAssigned: "No filter (assigned only)",
          outOfHours: "Outside available hours",
          movePast: "Nothing can be moved to the past",
          moveConfirmTitle: "Reschedule",
          moveConfirmText: "Move {{name}} from {{oldDateTime}} to {{newDateTime}}? We'll notify them via WhatsApp.",
          moveCancelar: "Cancel",
          moveConfirmar: "Confirm",
          moveSuccess: "Done, it was rescheduled",
          moveErrorGeneric: "Could not move it",
          moveOccupied: "That time slot is already taken",
          moveNoPermission: "You don't have permission to move {{appointmentPlural}}",
          moveDiscarded: "Couldn't drop it there. Try again, releasing it on the day and time you want.",
          refresh: "Refresh",
        },
        tabs: {
          agendaDesc: "Today at a glance, organized by who attends. You can call the next one and send a reminder.",
          profesionalesDesc: "Manage who takes {{appointmentPlural}}. You can add, edit or deactivate.",
          agendadoresDesc: "Who schedules {{appointmentPlural}} by hand and can enable extra slots. You can add, edit or deactivate.",
          serviciosDesc: "Set up what you offer, how long it takes and who handles it.",
          disponibilidadDesc: "Set working hours and schedule blocks, one by one.",
          preciosDesc: "The company price list. Imported from a file and editable by hand.",
          listaEsperaDesc: "Who is waiting for a slot, and the automatic rebalancing history.",
          recordatoriosDesc: "History of messages sent and scheduled.",
          ajustesDesc: "Integration settings, reminders and message templates.",
        },
        status: {
          available: "Available",
          reserved: "Reserved",
          completed: "Completed",
          cancelled: "Cancelled",
          pending: "Pending",
          confirmed: "Confirmed",
          in_progress: "In progress",
          arrived: "Checked in",
          called: "Called",
          no_show: "No show",
        },
        panel: {
          servicio: "Service",
          profesional: "Professional",
          fechaHora: "Date and time",
          consultorio: "Office",
          telefono: "Phone",
          sobreturno: "Overbooking",
          cambiarEstado: "Change status",
          estadoActualizado: "Status updated",
          estadoError: "Could not change status",
          notas: "Notes",
          acciones: "Actions",
          historial: "History",
          proximamente: "Coming soon",
          cerrar: "Close",
          notasVacio: "No notes yet",
          notaPlaceholder: "Add a note...",
          notaAgregar: "Add",
          notaCreada: "Note added",
          notaError: "Could not add the note",
          cancelarConMotivo: "Cancel with reason",
          cancelarMotivoLabel: "Reason",
          cancelarTitulo: "Cancel it",
          cancelarOk: "Cancelled, we notified them on WhatsApp",
          cancelarError: "Could not cancel",
          eliminar: "Delete",
          eliminarTitulo: "Delete it",
          eliminarTexto: "It's removed from the schedule, but stays in the history.",
          eliminarMotivoLabel: "Reason (optional)",
          eliminarOk: "Deleted",
          eliminarError: "Could not delete",
          reAvisarBtn: "Notify again",
          reAvisarOk: "Notification sent",
          reAvisarError: "Could not resend the notification",
          llamarBtn: "Call",
          llamarOk: "Moved to in progress",
          llamarError: "Could not call",
          abrirChatBtn: "Open chat",
          sinConversacion: "No conversation",
          sinTelefonoValido: "No valid phone number",
          dialogCancelar: "Cancel",
          dialogConfirmar: "Confirm",
          reprogramar: "Reschedule",
          reprogramarTitulo: "Reschedule",
          reprogramarFecha: "New date",
          reprogramarHorario: "Available time",
          reprogramarSinSlots: "No available times that day",
          reprogramarConfirmar: "Reschedule",
          reprogramarAviso: "We'll notify them on WhatsApp.",
          reprogramarOk: "Rescheduled, we notified them on WhatsApp",
          reprogramarError: "Could not reschedule",
          score: {
            cancelo: "Cancelled",
            ausente: "No-show",
            clienteRiesgo: "At-risk {{patient}}",
          },
        },
        aiBooked: "Booked by the AI assistant",
        manualBooked: "Entered manually",
        recoveredBooked: "♻ Recovered by rebalancing",
        overtime: {
          configurar: "Configure overbooking",
          finDelDia: "End-of-day overbooking",
          entreTurnos: "Extra slot in between",
          maxSobreturnos: "Max. overbookings per day",
          guardar: "Save",
          guardado: "Configuration saved",
          cancelar: "Cancel",
          yaHayTurno: "There's already something with {{name}} at that time",
          badge: "Overbooking",
          cargarSobreturno: "Add overbooking",
          activarHint: "Enable overbooking for today to add one",
          sinDisponibles: "No overbooking slots available",
        },
        atencion: {
          llego: "Arrived",
          llegoTooltip: "Mark that the client is here. Prevents the \"are you on your way?\" message",
          llegoOk: "{{nombre}}: arrival recorded",
          llegoError: "Could not record the arrival",
          llamar: "Call",
          llamarError: "Could not call",
          comenzarAtencion: "Start visit",
          comenzarError: "Could not start the visit",
          rellamar: "Recall",
          rellamarOk: "Notice resent",
          rellamarError: "Could not resend the notice",
          cancelarAusente: "Cancel (no-show)",
          confirmarAusenteTitulo: "Mark as no-show?",
          confirmarAusenteTexto: "The slot is freed up and it's recorded as a no-show.",
          ausenteOk: "Marked as no-show",
          ausenteError: "Could not mark as no-show",
          enAtencion: "In progress",
          terminarAtencion: "Finish visit",
          terminarError: "Could not finish the visit",
          horaObjetivo: "Target closing time",
          enMin: "in ~{{min}} min",
          etaTooltip: "Estimated attention time (recalculated)",
          avisoSonoroOn: "Sound alert on",
          avisoSonoroOff: "Sound alert off",
          nudgeSobreturno: "You're ahead — add an overbooking?",
          ahora: "Now",
          diaEnHora: "On time",
          diaAtrasado: "Running late +{{min}}min",
          diaAdelantado: "Ahead of schedule −{{min}}min",
          sugerido: "Suggested",
          fichaTitulo: "Called",
          fichaServicio: "Service",
          fichaTelefono: "Phone",
          minAbrev: "min",
        },
        header: {
          servicioActivo: "Service active",
          servicioNoDisponible: "Service unavailable",
          title: "TurnosIA — {{appointmentPlural_c}}",
          noAcceso: "You do not have access to this module.",
          contactarAdmin: "Contact the administrator to enable it.",
          volver: "Back",
          backendNoResponde: "The TurnosIA backend is not responding.",
        },
        agendaHoy: "Today's schedule",
        turnosHoy: "Today's appointments",
        proximosTurnos: "Coming up",
        sobretornosHoy: "Extra appointments enabled",
        sinTurnosHoy: "Nothing for today",
        sinTurnosProximos: "No appointments scheduled in the near future.",
        sinTurnosPropios: "You have nothing scheduled soon.",
        noTurnosHoy: "You have nothing for today.",
        vasAdelantado: "You are ahead of schedule. You can enable an extra slot for today.",
        profesionalAdelantado: "Running ahead of schedule. You can enable an extra slot for today.",
        misBloques: "My Special Blocks",
        sinSlots14Dias: "No slots in the next 14 days.",
        slotsEspecialesHoy: "Today's special slots",
        libresCount: "{{count}} available",
        reservadosCount: "{{count}} reserved",
        adelantado: "ahead",
        atrasado: "behind",
        ignorar: "Dismiss",
        tabAgenda: "Schedule",
        tabMisBloques: "My Blocks",
        profesional: "Professional",
        alertasTurnosEspeciales: "{{count}} special block alert{{plural}}",
        importTurnos: {
          boton: "Upload Excel",
          historialBoton: "Excel uploads",
          titulo: "Upload {{appointmentPlural}} from Excel",
          tabCargar: "Upload file",
          tabHistorial: "History",
          intro: "Upload the list from the previous system. You will see what changes first; nothing is saved until you confirm.",
          elegirArchivo: "Choose the file (.xls or .xlsx)",
          verConfig: "Upload settings",
          ocultarConfig: "Hide settings",
          servicioDefault: "Service used for the upload",
          servicioDefaultAyuda: "The file does not include the service: all rows are loaded with this one.",
          sinServicio: "Not set",
          recordatoriosDefault: "New uploads receive scheduled reminders",
          configGuardada: "Settings saved",
          errorConfig: "Could not save the settings",
          errorLeer: "Could not read the file",
          errorImportar: "Could not complete the upload",
          errorRevertir: "Could not revert the upload",
          noSePuedeImportar: "The file has problems and cannot be uploaded:",
          radio: "{{crear}} will be created and {{cancelar}} cancelled. No message is sent now.",
          radioRecordatorios: "{{n}} reminders will be scheduled.",
          radioSinRecordatorios: "These {{appointmentPlural}} will not receive reminders.",
          radioInmediatos: "{{n}} of those reminders go out in the next few minutes: their send time has already arrived.",
          rangoDeclarado: "File range: {{desde}} to {{hasta}} (declared on row {{fila}}).",
          rangoDerivado: "File range: {{desde}} to {{hasta}} (calculated from the rows: the file does not declare it).",
          sinRango: "The file range could not be determined.",
          rangoEfectivo: "Compared from {{desde}}: nothing earlier is created or cancelled.",
          servicioUsado: "Service: {{nombre}}",
          chipLeidas: "{{n}} rows read",
          chipCrear: "{{n}} to create",
          chipExistentes: "{{n}} already exist",
          chipPasadas: "{{n}} in the past (ignored)",
          chipCancelar: "{{n}} to cancel",
          chipIncidencias: "{{n}} issues",
          checksumOk: "Row check: {{leidas}} of {{declaradas}}",
          checksumMal: "Row check does NOT match: {{leidas}} read, {{declaradas}} declared",
          telefonos: "Phones: {{moviles}} with 15, {{asumidos}} assumed mobile, {{invalidos}} invalid",
          switchRecordatorios: "Send scheduled reminders to these {{appointmentPlural}}",
          switchRecordatoriosAyuda: "The booking confirmation is not sent: the customer already arranged it with the advisor.",
          asesoresTitulo: "Advisors in the file and their {{professional}}",
          asesoresSinAsociar: "{{n}} not linked: their rows are not loaded",
          sinAsociar: "Not linked",
          guardarAsesores: "Save links",
          cancelarTitulo: "{{n}} {{appointmentPlural}} will be cancelled",
          cancelarAyuda: "They were loaded from a previous file and are not in this one. Anything booked by the assistant or entered by hand is never cancelled.",
          colCliente: "Customer",
          colSucursal: "{{professional_c}}",
          colFecha: "Date",
          colHora: "Time",
          incidenciasTitulo: "{{n}} rows with issues (not loaded)",
          protegidosTitulo: "{{n}} {{appointmentPlural}} are not cancelled because their row has an issue",
          protegido: "{{cliente}} — {{fecha}} {{hora}}",
          fila: "Row {{n}}",
          archivo: "File",
          importado: "Upload #{{lote}}: {{creados}} created, {{cancelados}} cancelled",
          importadoConIncidencias: "{{n}} rows were not loaded: check the issues in the history",
          revertido: "Upload #{{lote}} reverted: {{borrados}} deleted, {{restaurados}} restored",
          revertResultado: "Upload #{{lote}} reverted: {{borrados}} deleted and {{restaurados}} restored.",
          revertPasosSaltados: "{{n}} reminders that became due while the appointment was cancelled will not be sent.",
          noRevertiblesTitulo: "{{n}} were not reverted (they changed after the upload):",
          historialVacio: "No uploads yet.",
          colCargado: "Uploaded",
          colArchivo: "File",
          colRango: "Range",
          colCreados: "Created",
          colCancelados: "Cancelled",
          colExistentes: "Already existed",
          colIncidencias: "Issues",
          colEstado: "Status",
          estadoRevertido: "Reverted",
          estadoAplicado: "Applied",
          sinRecordatorios: "no reminders",
          revertir: "Revert",
          historialAyuda: "Only the last applied upload can be reverted.",
          cerrar: "Close",
          confirmar: "Confirm: create {{crear}} and cancel {{cancelar}}",
          revertirTitulo: "Revert upload #{{lote}}",
          revertirTexto: "The {{creados}} {{appointmentPlural}} it created are deleted (except those that already changed) and the {{cancelados}} it cancelled are restored. No message is sent."
        },
      },
      agenda: {
        cargarAMano: "Add by hand",
        asignarA: "Assign to",
        sinRecurrencia: "No recurrence",
        sinAcceso: "No access",
        accesoPermanente: "Permanent access",
        accesoPorCaso: "Case by case (needs approval)",
        placeholderBloque: "e.g. check-up, review, urgent",
        alertasTitulo: "Alerts for cancelled special blocks",
        sinAlertas: "No pending alerts.",
        sinAsignados: "You have nothing assigned yet.",
        color: "Color:",
        slot: "Slot:",
        nombrePaciente: "Patient name *",
        telefono: "Phone *",
        email: "Email (optional)",
        profesional: "Professional",
        profesionalReq: "Professional *",
        servicio: "Service *",
        helperTelefono: "With country code, e.g.: 5493512345678",
        nombreBloque: "Block name *",
        inicio: "Start *",
        fin: "End *",
        duracionSlot: "Slot duration (minutes)",
        recurrencia: "Recurrence",
        accesoAgendador: "{{scheduler_c}} access",
        fecha: "Date *",
        sinSlots: "No available slots for that date",
        seleccionarProfFechaSvc: "Select {{professional}}, date and {{service}}",
        guardarTurno: "Save",
        asignar: "Assign",
        crearBloque: "Create block",
        habilitarSobreturno: "Enable extra appointment",
        habilitarSobreturnos: "Enable extra appointments",
        solicitarAcceso: "Request access",
        actualizar: "Update",
        llamarSiguiente: "Call next",
        llamar: "Call",
        enviarRecordatorio: "Send reminder",
        agendadorSinAcceso: "{{scheduler_c}} without access",
        agendadorConAcceso: "{{scheduler_c}} with access",
        desactivarBloque: "Deactivate block",
        especial: "Special",
        libre: "Available",
        reservado: "Reserved",
        pacienteNotificado: "Notified via WhatsApp",
        turnoActualizadoSinWA: "Updated, but WhatsApp was unavailable",
        errorLlamarSiguiente: "Error calling next",
        recordatorioEnviado: "Reminder sent",
        errorRecordatorio: "Error sending reminder",
        sobreturnuHabilitado: "Extra appointment enabled for today",
        errorSobreturno: "Could not enable extra appointment",
        sobretornosHabilitados: "Extra appointments enabled for today",
        sobretornosDeshabilitados: "Extra appointments disabled",
        errorSobreturnos: "Error updating extra appointments",
        bloqueCreado: "Special block created",
        errorBloque: "Error creating block",
        pacienteAsignado: "Assigned to the special block",
        errorAsignar: "Could not assign it",
        errorAsignarSimple: "Error assigning",
        solicitudEnviada: "Request sent",
        errorSolicitud: "Error sending request",
        errorAcceso: "Could not update access",
        bloqueDesactivado: "Block deactivated",
        errorDesactivar: "Error deactivating block",
        errorCargarDatos: "Error loading data",
        camposObligatorios: "Fill in all required fields (*)",
        campoRequerido: "The field \"{{label}}\" is required",
        eligeHorario: "Choose a time slot",
        turnoCargado: "Done, it's booked",
        errorCargarTurno: "Could not book it",
        usuarioSinProfesional: "Your user is not linked. Contact the administrator.",
        errorProfesionales: "Could not load the list.",
      },
      profesionales: {
        titulo: "Professionals",
        agregarBtn: "Add",
        headerNombre: "Name",
        headerEspecialidad: "Specialty",
        headerCapacidad: "Simultaneous",
        headerCupoDiario: "Daily cap",
        headerEstado: "Status",
        headerAcciones: "Actions",
        sinProfesionales: "You haven't added any {{professionalPlural}} yet.",
        sinEspecialidad: "No {{specialty}}",
        cancelar: "Cancel",
        nuevo: "Add {{professional}}",
        editar: "Edit {{professional}}",
        activo: "Active",
        inactivo: "Inactive",
        activar: "Activate",
        desactivar: "Deactivate",
        nombre: "Name *",
        especialidad: "Specialty",
        emailReq: "Email *",
        email: "Email",
        passwordReq: "Password *",
        nuevaPassword: "New password",
        helperPassword: "Leave blank to keep unchanged",
        consultorio: "Office",
        capacidad: "Simultaneous capacity",
        capacidadUnidad: "appointments",
        capacidadAyuda: "How many {{appointmentPlural}} can be handled at the same time (1 = one at a time)",
        cupoDiario: "Daily appointment cap",
        cupoDiarioAyuda: "Optional. Empty = no cap. It limits what the assistant books; from the panel you can still add one.",
        diasAFuturo: "Days ahead for booking",
        diasAFuturoAyuda: "Optional. Empty = the company setting. How many days ahead bookings can be made for this resource (never more than the company limit).",
        anticipacionMinima: "Minimum notice for appointments (days)",
        anticipacionMinimaAyuda: "Optional. Empty = the company setting. The minimum number of days ahead the AI assistant can offer and book for this resource (never less than the company setting). Closer days are booked by staff from the panel.",
        consultorioPlaceholder: "e.g. 1, 3, A",
        queueWarning: "The user was created but a queue could not be assigned. Please assign one manually from WAIA.",
        guardar: "Save",
        errorNombre: "Name is required",
        errorCredenciales: "Email and password are required",
        errorGuardar: "Could not save. Check the data and try again.",
        tooltipEditar: "Edit",
        avisoMailLabel: "Notice emails for {{elProfessional}}",
        avisoMailPlaceholder: "e.g. frontdesk@company.com, manager@company.com",
        avisoMailAyuda: "Optional. Gets only the {{appointmentPlural}} of {{elProfessional}} handled by the AI assistant. Separate several with commas (up to 10). This is not the login email.",
        avisoMailInvalidas: "These addresses are not valid: {{list}}",
        avisoMailDemasiadas: "You can enter up to {{max}} addresses.",
        emailIngresoAyuda: "This is the user to log in. It does not receive notices.",
        headerAvisoMail: "Email notice",
        avisoMailSin: "No own notice",
        avisoMailCount: "{{count}} address(es)",
        avisoMailSwitch: "Email notice on",
        avisoMailSwitchAyuda: "When off, the addresses below get no notices but stay saved. The company list still gets everything.",
        avisoMailApagado: "Off ({{count}} address(es))",
      },
      precios: {
        titulo: "Prices",
        importar: "Import",
        historial: "History",
        sinLista: "You have not imported a price list yet.",
        vigenteDesdeChip: "Effective from {{fecha}}",
        importadaEl: "Imported on {{fecha}}",
        listaVencida: "This list is {{dias}} days old and the configured limit is {{umbral}}. Update it: the assistant will not quote prices from an expired list.",
        buscar: "Search",
        todos: "All",
        headerPrecio: "Price",
        headerAcciones: "Actions",
        headerItems: "Prices",
        headerEstado: "Status",
        noAplica: "Not applicable",
        estadoActivo: "Has a price",
        sinResultados: "No price matches the filter.",
        editar: "Correct",
        editarTitulo: "Correct price",
        etiqueta: "Label",
        helperPrecio: "Leave it empty if there is no price loaded.",
        helperEtiqueta: 'For named offers, such as "Free Inspection". It is said instead of the number.',
        avisoAtributos: "To change what this price applies to, fix the file and import it again.",
        rangoFiltroPlaceholder: "Type a value",
        borrarLista: "Delete",
        estado_active: "In use",
        estado_archived: "Archived",
        estado_draft: "Draft",
        importarTitulo: "Import price list",
        formato: "Spreadsheet type",
        formato_matrix_km: "One row per vehicle and one column per mileage",
        formato_long_csv: "CSV: one price per row",
        formatoHelp_matrix_km: "The usual wall chart: each row is a model, each column a service (10,000, 20,000…) and the add-ons at the end.",
        formatoHelp_long_csv: "One row per price. Columns other than price, status, label or note are taken as price details.",
        formato_ejes_declarados: "With a configuration sheet (CONFIG)",
        formatoHelp_ejes_declarados: "The new spreadsheet: besides the prices it has a CONFIG sheet saying what each column is (model, version, years, mileage).",
        rechazan: "{{count}} problem prevents importing",
        cobertura: "Coverage per subject",
        sinPreciosPara: "no prices for {{v}}",
        dejarEnBorrador: "Keep as draft (does not replace the live list yet)",
        avisoBorrador: "The list is loaded but NOT put in use: you can review it and activate it later. The assistant keeps answering with the live list.",
        elegirArchivo: "Tap here to choose the file (.xlsx or .csv)",
        resumen: "What the file contains",
        ejes: "Grouped by",
        chipTotal: "{{n}} prices",
        chipActivos: "{{n}} with a price",
        chipNoAplica: "{{n}} not applicable",
        chipOmitidas: "{{n}} will not load",
        diffPrimera: "First list: everything is new.",
        diffContra: 'Compared with "{{lista}}"',
        diffNuevos: "{{n}} new",
        diffSubieron: "{{n}} went up",
        diffBajaron: "{{n}} went down",
        diffIguales: "{{n}} unchanged",
        diffCambiosEstado: "{{n}} change status",
        diffDesaparecidos: "{{n}} disappear",
        diffItem: "Item",
        diffAntes: "Before",
        diffDespues: "Now",
        diffCambio: "Change",
        diffKind_nuevo: "New",
        diffKind_subio: "Went up",
        diffKind_bajo: "Went down",
        diffKind_igual: "Unchanged",
        diffKind_cambio_estado: "Status change",
        diffKind_desaparecido: "Disappears",
        noSeCargan: "{{count}} cell will not be loaded",
        avisos: "{{count}} notice",
        nombreLista: "List name",
        vigenteDesde: "Effective from",
        vigenciaDelArchivo: "Taken from the file. Change it if it is wrong.",
        vigenciaFaltante: "The file does not include it: set when it takes effect.",
        incluyeIva: "Do prices include VAT?",
        ivaSi: "Yes, VAT included",
        ivaNo: "No, VAT not included",
        ivaNoSe: "Unknown",
        avisoReemplazo: "On confirming, this list becomes the active one and the previous one is archived.",
        errorLeer: "The file could not be read.",
        errorImportar: "The file could not be imported.",
        validezTitulo: "Price list expiry",
        validezLabel: "Warn when the list is older than (days)",
        validezHelper: "Empty = no expiry control. With a number, the list is flagged as expired after those days and the assistant stops quoting from it.",
        formatoDetectado: "Spreadsheet type (recognized automatically)",
        formatoDetectadoHelp: "We picked it by looking at the file. Change it only if it's wrong: the file is read again.",
        importarAyuda: "This is the price list the assistant uses to answer questions. Upload the Excel file the company keeps: before saving anything we show you what it contains, what changes against the current list and what needs fixing.",
        archivoElegido: "{{nombre}} — tap to choose another",
        leyendoArchivo: "Reading the file…",
        rechazan_plural: "{{count}} problems prevent importing",
        rechazanAyuda: "Fix them in the Excel file (the cell is next to each one) and choose the file again.",
        noSeCargan_plural: "{{count}} cells will not be loaded",
        avisos_plural: "{{count}} notices",
        incGenerico: "{{count}} case",
        incGenerico_plural: "{{count}} cases",
        incVerTodas: "Show all {{n}}",
        incVerMenos: "Show less",
        incMasCeldas: "and {{n}} more",
        inc_CELDA_CON_ERROR: "{{count}} cell with a formula error",
        inc_CELDA_CON_ERROR_plural: "{{count}} cells with a formula error",
        inc_COLUMNA_IGNORADA: "{{count}} column that is not a valid mileage",
        inc_COLUMNA_IGNORADA_plural: "{{count}} columns that are not a valid mileage",
        inc_CONFIG_CLAVE_IGNORADA: "{{count}} CONFIG entry that is not used",
        inc_CONFIG_CLAVE_IGNORADA_plural: "{{count}} CONFIG entries that are not used",
        inc_CONFIG_IVA_ILEGIBLE: "The VAT entry in CONFIG could not be read",
        inc_CONFIG_IVA_ILEGIBLE_plural: "The VAT entry in CONFIG could not be read",
        inc_EJES_INFERIDOS: "The columns were recognized automatically",
        inc_EJES_INFERIDOS_plural: "The columns were recognized automatically",
        inc_ESCALA_CON_SALTO: "{{count}} gap in the mileages (a column may be missing)",
        inc_ESCALA_CON_SALTO_plural: "{{count}} gaps in the mileages (a column may be missing)",
        inc_FILA_SIN_PRECIOS: "{{count}} row without any price",
        inc_FILA_SIN_PRECIOS_plural: "{{count}} rows without any price",
        inc_ITEM_DUPLICADO: "{{count}} repeated price",
        inc_ITEM_DUPLICADO_plural: "{{count}} repeated prices",
        inc_MONEDA_IGNORADA: "The currency column is not used",
        inc_MONEDA_IGNORADA_plural: "The currency column is not used",
        inc_PRECIO_CERO_CON_ETIQUETA: "{{count}} zero price that is said with its note",
        inc_PRECIO_CERO_CON_ETIQUETA_plural: "{{count}} zero prices that are said with their note",
        inc_PRECIO_CERO_SIN_ETIQUETA: "{{count}} zero price without a note",
        inc_PRECIO_CERO_SIN_ETIQUETA_plural: "{{count}} zero prices without a note",
        inc_PRECIO_COMO_TEXTO: "{{count}} price written as text",
        inc_PRECIO_COMO_TEXTO_plural: "{{count}} prices written as text",
        inc_RANGO_CON_HUECO: "{{count}} gap between years",
        inc_RANGO_CON_HUECO_plural: "{{count}} gaps between years",
        inc_RANGO_INVALIDO: "{{count}} badly written year range",
        inc_RANGO_INVALIDO_plural: "{{count}} badly written year ranges",
        inc_SEPARADOR_AMBIGUO: "{{count}} price with an unclear separator",
        inc_SEPARADOR_AMBIGUO_plural: "{{count}} prices with an unclear separator",
        inc_SUJETO_INCOMPLETO: "{{count}} row with prices but no model",
        inc_SUJETO_INCOMPLETO_plural: "{{count}} rows with prices but no model",
        inc_SUJETO_VARIAS_PALABRAS: "{{count}} value with extra words",
        inc_SUJETO_VARIAS_PALABRAS_plural: "{{count}} values with extra words",
        inc_TEXTO_COMO_ETIQUETA: "{{count}} text loaded as a label",
        inc_TEXTO_COMO_ETIQUETA_plural: "{{count}} texts loaded as labels",
        inc_RANGO_SOLAPADO: "{{count}} pair of rows whose years overlap",
        inc_RANGO_SOLAPADO_plural: "{{count}} pairs of rows whose years overlap",
        inc_RANGO_DOS_ABIERTOS: "{{count}} model with two rows without \"to\"",
        inc_RANGO_DOS_ABIERTOS_plural: "{{count}} models with two rows without \"to\"",
        ivaHelp_si: "The assistant may say that prices include VAT.",
        ivaHelp_no: "The assistant may clarify that prices do not include VAT.",
        ivaHelp_nose: "The assistant does not mention VAT.",
        ivaSiCorto: "Included",
        ivaNoCorto: "Not included",
        ivaNoSeCorto: "Unknown",
        incluyeIvaCorto: "VAT",
        crearPrecios: "Create {{count}} price",
        crearPrecios_plural: "Create {{count}} prices",
        crearBorrador: "Create {{count}} price as a draft",
        crearBorrador_plural: "Create {{count}} prices as a draft",
        crearSinArchivo: "Create prices",
        creando: "Creating…",
        motivoSinArchivo: "Choose a file to start.",
        motivoNoSeLeyo: "The file could not be read: see the message above.",
        motivoErrores: "Can't import: there is {{count}} problem in the file, marked in red.",
        motivoErrores_plural: "Can't import: there are {{count}} problems in the file, marked in red.",
        motivoVacio: "The file has no prices to load.",
        motivoSinVigencia: "Say from when the list applies.",
        cancelar: "Cancel",
        guardar: "Save",
        cerrar: "Close",
        historialAyuda: "The list «In use» is the one the assistant checks. A draft does not replace it until you activate it.",
        borradoresTitulo: "There is {{count}} draft list not yet activated",
        borradoresTitulo_plural: "There are {{count}} draft lists not yet activated",
        borradoresAyuda: "The assistant still uses «{{vigente}}». Review the draft and activate it when it's ready.",
        borradoresAyudaSinVigente: "No list is in use yet: the assistant gives no prices until you activate one.",
        borradorDetalle: "{{n}} prices · imported on {{fecha}}",
        verPrecios: "View prices",
        probar: "Test",
        activar: "Activate",
        viendoLista: "You're viewing «{{lista}}» ({{estado}}). It is not the list the assistant uses.",
        volverAVigente: "Back to the list in use",
        activarTitulo: "Activate «{{lista}}»",
        activarFrase: "The list «{{nueva}}» becomes the one the assistant uses. The current «{{actual}}» gets archived.",
        activarFraseSinVigente: "The list «{{nueva}}» becomes the one the assistant uses.",
        activarColVigente: "In use now",
        activarColNueva: "Incoming",
        activarProbarAntes: "Not sure? Test it first: look up a real vehicle and compare what each list would answer.",
        activarBoton: "Activate",
        activarError: "The list could not be activated.",
        activada: "«{{lista}}» is now the list the assistant uses.",
        chipActivosCorto: "With price",
        incidencias: "Import issues",
        incNinguna: "None",
        incNoRegistradas: "Not recorded",
        incNoRegistradasAyuda: "This list was imported before issues were recorded. To see them, choose the same file again in Import (the preview saves nothing).",
        incQuedaronAfuera: "{{count}} cell was left out",
        incQuedaronAfuera_plural: "{{count}} cells were left out",
        borrarTitulo: "Delete list",
        borrarFrase: "«{{lista}}» and its {{n}} prices will be deleted. This cannot be undone. The list in use does not change.",
        borrarBoton: "Delete",
        borrarError: "The list could not be deleted.",
        borrada: "«{{lista}}» was deleted.",
        importadaBorrador: "«{{lista}}» was saved as a draft. Activate it once you've reviewed it.",
        importadaVigente: "The new list is now in use.",
        probarTitulo: "Test «{{lista}}»",
        probarAyuda: "Run the same lookup the assistant would do with a real customer.",
        probarAyudaComparar: "Run the same lookup the assistant would do, and compare with what «{{vigente}}» answers today.",
        probarVehiculo: "Vehicle",
        probarRango: "year",
        probarUltimoService: "Last service (km)",
        probarKmActual: "Current km",
        probarItemOpcional: "Add-on (optional)",
        probarConsultar: "Look up",
        probarError: "The lookup failed.",
        probarEsta: "«{{lista}}»",
        probarEnUso: "In use: «{{lista}}»",
        probarModelo: "Model",
        probarItem: "Item",
        probarServiceQueToca: "Service due: {{km}} km",
        probarAtrasado: "Overdue by {{km}} km",
        probarFalta: "Missing: {{dato}}",
        probarRes_precio: "Gives a price",
        probarRes_no_aplica: "Does not apply to that vehicle",
        probarRes_modelo_ambiguo: "Asks which model",
        probarRes_item_ambiguo: "Asks which add-on",
        probarRes_anio_faltante: "Asks for the {{eje}}",
        probarRes_anio_sin_cobertura: "No price for that {{eje}} → hands over",
        probarRes_falta_dato: "Asks for missing data",
        probarRes_km_incoherentes: "Mileage doesn't add up (current is lower than last service) → checks with the customer",
        probarRes_sin_dato: "No price found → hands over to an agent",
        probarRes_fuera_de_grilla: "Mileage outside the list → hands over",
        probarRes_salteo_intervalos: "Services were skipped → hands over",
        probarRes_lista_vencida: "Expired list → hands over without a price",
        probarRes_sin_lista: "No list → hands over",
      },
      servicios: {
        titulo: "Services",
        tituloSeccion: "Services",
        nuevo: "Add {{service}}",
        editar: "Edit {{service}}",
        activo: "Active",
        inactivo: "Inactive",
        activar: "Activate",
        desactivar: "Deactivate",
        cualquiera: "Any",
        nombre: "Name *",
        duracion: "Duration (minutes)",
        profesionalAsignado: "Who handles it",
        guardar: "Save",
        cancelar: "Cancel",
        tooltipEditar: "Edit",
        headerNombre: "Name",
        headerDuracion: "Duration",
        headerEntrega: "Delivery",
        headerPrecio: "Price",
        precio: "Price",
        helperPrecio: "Optional. In your country's currency — no need to specify it.",
        helperDuracion: "How much it takes up in the schedule (the step of the time grid).",
        entrega: "Delivery time (minutes)",
        helperEntrega: "Optional. When the finished work is handed back. It does not take up the schedule: it is what the assistant tells the customer.",
        descripcion: "Description",
        helperDescripcion: "Optional. Shown to {{elPatient}}, and it helps the assistant tell which {{service}} they mean.",
        headerProfesional: "Professional",
        headerEstado: "Status",
        headerAcciones: "Actions",
        agregarBtn: "Add",
        sinServicios: "You haven't added any {{servicePlural}} yet.",
        borrar: "Delete permanently",
        borrarTitulo: "Delete {{service}}",
        borrarTexto: "\u201C{{name}}\u201D is removed from the list, for good. Deactivating takes it out of circulation but keeps it in the history; this does not.",
        borrarConfirmar: "Delete",
        borrarCancelar: "Cancel",
        borrarOk: "Done, it was deleted",
        borrarEnUso: "Can't delete: it has {{count}} {{appointmentPlural}} in its history. It can only be deactivated.",
        borrarEnUsoOtros: "Can't delete: it is still in use elsewhere in the system. It can only be deactivated.",
        borrarError: "Couldn't delete it",
      },
      agendadores: {
        titulo: "Secretaries",
        tituloSeccion: "Secretaries",
        descripcion: "Who schedules {{appointmentPlural}} by hand, for {{losProfessionalPlural}} assigned to them. They can also enable extra slots on specific days.",
        nuevo: "Add {{scheduler}}",
        editar: "Edit {{scheduler}}",
        activo: "Active",
        inactivo: "Inactive",
        activar: "Activate",
        desactivar: "Deactivate",
        nombre: "Name *",
        email: "Email",
        emailReq: "Email *",
        passwordReq: "Password *",
        nuevaPassword: "New password (optional)",
        helperPassword: "Leave blank to keep unchanged",
        guardar: "Save",
        cancelar: "Cancel",
        tooltipEditar: "Edit",
        errorNombre: "Name is required",
        errorCredenciales: "Email and password are required",
        errorEmailOtroPerfil: "That email already belongs to a user with the {{perfil}} profile in this company. Use a different email: the password you typed is not applied to an existing user.",
        errorGuardar: "Could not save. Please try again.",
        usuarioReutilizado: "That user already existed in WAIA: they sign in with their previous password, the one you typed was not applied.",
        perfil: {
          admin: "admin",
          user: "user",
          profesional: "professional",
          agendador: "secretary",
          desconocido: "unknown",
        },
        headerNombre: "Name",
        headerEmail: "Email",
        headerProfesionales: "Assigned professionals",
        headerEstado: "Status",
        headerAcciones: "Actions",
        agregarBtn: "Add",
        sinAgendadores: "You haven't added any {{schedulerPlural}} yet.",
        sinAsignacion: "No assignment",
        profesionalesLabel: "Assigned professionals",
        noProfesionales: "No {{professionalPlural}} available yet.",
      },
      recordatorios: {
        titulo: "Reminders",
        tipo: "Type",
        estado: "Status",
        pendiente: "Pending",
        enviado: "Sent",
        fallido: "Failed",
        respondido: "Replied",
        saltado: "Skipped",
        todosLosTipos: "All types",
        todosLosEstados: "All statuses",
        historial: "Reminder history",
        seguimiento: "Tracking of the reminders sent. The system sends them on its own, following the company settings.",
        paciente: "Patient",
        programadoPara: "Scheduled for",
        vistaPrev: "Preview",
        noHayRegistros: "No reminders recorded",
        sinDatos: "No reminder data available",
        confirmacionReserva: "Booking confirmation",
        recordatorioSimple: "Reminder",
        solicitudConfirmacion: "Confirmation request",
        ofertaRebalanceo: "Rebalancing offer",
        ofertaListaEspera: "Waiting list offer",
      },
      configuracion: {
        titulo: "Availability configuration",
        horariosAtencion: "Working hours",
        agregarHorario: "Add hours",
        dia: "Day",
        desde: "From",
        hasta: "To",
        acciones: "Actions",
        sinHorarios: "No working hours configured",
        cupoVentana: "Slot cap",
        cupoVentanaAyuda: "Optional. Empty = no cap. How many appointments this time slot takes; it limits the assistant, not the panel.",
        editar: "Edit",
        editarHorario: "Edit hours",
        bloqueosAgenda: "Schedule blocks",
        agregarBloqueo: "Add block",
        motivo: "Reason",
        sinBloqueos: "No blocks",
        eliminar: "Delete",
        diaSemana: "Day of the week",
        horaInicio: "Start time",
        horaFin: "End time",
        fechaHoraInicio: "Start date/time",
        fechaHoraFin: "End date/time",
        motivoOpcional: "Reason (optional)",
        cancelar: "Cancel",
        guardar: "Save",
      },
      listaEspera: {
        titulo: "Waiting List",
        descripcion: "Who asked for a slot and found none available. We notify them automatically if something compatible frees up.",
        tituloLista: "Waiting list",
        profesional: "Professional",
        servicio: "Service",
        estado: "Status",
        cualquiera: "Any",
        todos: "All",
        tooltipEliminar: "Remove from list",
        enEspera: "Waiting",
        ofertaEnviada: "Offer sent",
        confirmado: "Confirmed",
        expirado: "Expired",
        eliminado: "Removed",
        pendiente: "Pending",
        enCurso: "In progress",
        completado: "Completed",
        fallido: "Failed",
        abandonado: "Abandoned",
        listaEspera: "Waiting list",
        adelantamiento: "Advance",
        eliminar: "Remove",
        cancelar: "Cancel",
        headerPaciente: "Patient",
        headerProfesional: "Professional",
        headerServicio: "Service",
        headerPedido: "Requested day/time",
        sinPreferencia: "No preference",
        headerIngreso: "Added",
        headerVence: "Expires",
        headerEstado: "Status",
        headerAcciones: "Actions",
        noHayPacientes: "Nobody is waiting.",
        enEsperaCount: "{{count}} waiting",
        historialRebalanceos: "Rebalancing history",
        histHeaderId: "ID",
        histHeaderTurno: "Freed slot",
        histHeaderProfesional: "Professional",
        histHeaderEstado: "Status",
        histHeaderFase: "Phase",
        histHeaderIntentos: "Attempts",
        histHeaderIniciado: "Started",
        sinHistorial: "No rebalancing history",
        eliminarDialogTitle: "Remove from waiting list",
        confirmarEliminar: "Confirm removal of",
        estePaciente: "this person",
        deListaEspera: "from the waiting list? This action cannot be undone.",
      },
      identificadorContacto: {
        title: "Contact identifier",
        help: "The data that identifies what the contact brings in —the licence plate at a workshop, the pet's name at a vet, the serial number at a repair shop—. It is shown next to the name in the chat and in the contact card. If there is more than one key, the first one with a value is used.",
        clave: "Profile key",
        etiqueta: "Label",
        fichas: "{{n}} profiles with data",
        agregar: "Add key",
        quitar: "Remove",
        guardar: "Save",
        guardado: "Identifier saved",
        sinFichas: "No profiles loaded yet: keys show up when the first campaign comes in. You can still type the key.",
        vacio: "No identifier: nothing is shown next to the name.",
        max: "Up to 3 keys.",
      },
      reminderStepTemplate: {
        title: "WhatsApp template for this step",
        help: "Optional. If you pick an approved template, this step is sent with it and each numbered variable is filled with the variable you choose. Without one, it is sent as always (Message templates text and template by day).",
        templateLabel: "Approved template",
        automatic: "Automatic (as always)",
        varCount: "{{count}} variable(s)",
        notApproved: "no longer approved",
        noneApproved: "The company line has no approved templates.",
        unavailable: "Could not load the approved templates. Try again later.",
        varPlaceholder: "e.g. fecha_ddmmaaaa or dato.patente",
        varsHelp: "Variables: nombre, fecha, fecha_ddmmaaaa (DD/MM/YYYY), hora, servicio, profesional, empresa… and dato.<key> for the appointment's own data (e.g. dato.patente). If an appointment lacks the data, that reminder is not sent.",
        errorVarsIncompletas: "Fill in the variable for every numbered variable of the template.",
        errorGuardar: "The step could not be saved.",
        chipTooltip: "Chosen template: {{vars}}",
        category: {
          UTILITY: "Utility",
          MARKETING: "Marketing",
          AUTHENTICATION: "Authentication",
        },
        superadmin: {
          overridesNote: "This choice wins: if a step has a template here, it is sent with it even if the manual mapping above or “Message templates” shows another one (for example recordatorio_turno).",
          title: "Template per reminder",
          help: "Which WhatsApp template each scheduled reminder of this company uses. It is the same choice the admin sees in Settings › Reminders › edit step.",
          step: "Step {{n}} · {{hours}} h before",
          inactive: "inactive",
          current: "Currently sent with: {{name}}",
          save: "Save",
          saved: "Step template saved",
          applyAll: "Use this choice in every step",
          appliedAll: "Template applied to every step",
          noSteps: "This company has no reminder steps.",
          loadError: "Could not load the reminder configuration.",
          marketing: "This is a Marketing template: Meta charges more for it and may limit its delivery. If there is a Utility one with the same text, prefer that one.",
        },
      },
      ajustes: {
        voiceTemplateDefault: "{nombre}, please go to {consultorio}, with {profesional}. Again: {nombre}, please go to {consultorio}.",
        salaProfesionales: "{{professionalPlural_c}} (empty = no filter)",
        salaSoloInicial: "Show only the last name initial",
        salaDing: "Ding dong on every call",
        salaVoz: "Voice announcement",
        salaProximos: "Show who is next",
        salaAnteriores: "Show who has already been seen",
        nombreNegocio: "Business name",
        nombreNegocioPlaceholder: "E.g. Junín Garage, Gazzera Clinic",
        avisoMail: {
          switchLabel: "Email notice on",
          switchAyuda: "When off, no email notice is sent for the company, including each {{professional}}'s own. Addresses stay saved.",
          salteado: "not sent ({{reason}})",
          motivo: { empresa_apagada: "notice off for the company", recurso_apagado: "resource notice off" },
          titulo: "Email notice when the assistant handles an appointment",
          cuando: "An email is sent every time the AI assistant books, reschedules or cancels an appointment over WhatsApp.",
          cuandoNo: "Nothing entered from the panel, by Excel import or through the notices API is notified.",
          recursos: "Also, each {{professional}} can have its own list (in {{professionalPlural_c}}): it gets only the notices of its own {{appointmentPlural}}. An address on both lists gets a single email.",
          label: "Notice addresses",
          placeholder: "e.g. owner@company.com, desk@company.com",
          help: "Separate several addresses with commas (up to 10). Empty = no notice.",
          invalidas: "These addresses are not valid: {{list}}",
          demasiadas: "You can enter up to {{max}} addresses.",
          guardar: "Save addresses",
          ultimos: "Latest notices sent",
          enviado: "sent",
          fallo: "failed ({{reason}})",
          evento: { created: "Booking", rescheduled: "Reschedule", cancelled: "Cancellation" },
          estado: {
            apagado: "Email notice is off: nothing is sent. The addresses stay saved.",
            recursos_apagados: "The {{professionalPlural}} with an address have their notice off and there are no company addresses: nothing is sent.",
            ok: "{{count}} address(es) are notified using {{brand}}'s mail server.",
            sin_direcciones: "No addresses entered: no notice is sent.",
            no_determinado: "Could not check whether this company can send email.",
            sin_smtp: "Addresses are entered, but this company's brand has no mail server configured: notices will not go out.",
            solo_recursos: "No general addresses: {{n}} of {{total}} {{professionalPlural}} notify their own list.",
            okConRecursos: "{{count}} address(es) are notified using {{brand}}'s mail, and {{n}} of {{total}} {{professionalPlural}} also notify their own list.",
            ultimo_fallo: "The last notice failed ({{reason}})."
          }
        },
        grupoAgendaVentana: "Schedule → Booking window",
        dias: "days",
        metaEnRevision: "Under review",
        metaNoCreada: "Not created",
        metaDentro24: "within 24 hours",
        metaNoRequieren: "do not need Meta approval",
        metaAprobada: "Meta-approved template",
        metaSoloLectura: "read only",
        solicitudConfirmacion: "Confirmation request",
        opModoTitle: "Operation mode",
        opModoDesc: "Defines what the AI does when it can't resolve something and who the case goes to.",
        opModoActivo: "Current",
        opModoLocked: "Available in a higher plan — contact us to enable it",
        opEffectiveLabel: "Who cases go to today:",
        opGuardarModo: "Save mode",
        opDestinatarioChat: "+ WhatsApp chat",
        opModo: {
          desatendido: {
            title: "Unattended",
            desc: "The AI handles everything. If it can't resolve something, it leaves the case for you to see in your agenda. It doesn't promise live human support.",
          },
          atendido: {
            title: "Attended",
            desc: "The AI handles it; cases it can't resolve go to the secretary / scheduler.",
          },
          con_chat: {
            title: "With chat",
            desc: "Additionally, your team can reply from the WhatsApp chat. The AI can hand off to a person.",
          },
        },
        opDestinatario: {
          profesionales: "The professionals (each case appears in the agenda of the appointment's professional)",
          rol: "The secretary / scheduler",
          usuario: "A designated user",
          admin: "The administrator",
        },
        grupoAsistente: "Assistant",
        // ── AI switch ─────────────────────────────────────────────────────
        // The copy says what it does AND what it does NOT do: turning the AI
        // off does not turn reminders off, and that confusion leaves a company
        // with no product.
        iaOn: "The assistant answers incoming messages",
        iaOff: "The assistant does NOT answer: a person handles it",
        iaDesc: "With the assistant off, incoming messages are not handed to the AI: they stay in the Chats inbox for a person to handle. This is an operating mode, not a maintenance mode — you can leave it off for as long as you want.",
        iaNoApagaRecordatorios: "⛔ Turning the assistant off does NOT turn reminders off: scheduled reminders, booking confirmations and outbound campaigns keep going out.",
        iaUltimoCambio: "Last change:",
        iaPorUsuario: "by user",
        iaPrendidaOk: "The assistant answers incoming messages again.",
        iaApagadaOk: "Assistant off. Incoming messages stay in the inbox. Reminders keep going out.",
        iaNoHabilitada: "The assistant is not enabled for your account",
        iaNoHabilitadaDesc: "This feature is not enabled for your account. Get in touch if you want it turned on.",
        remTitle: "Scheduled reminders",
        remOn: "Scheduled reminders go out",
        remOff: "Scheduled reminders do NOT go out",
        remDesc: "The steps you have configured below (30 days before, 24 hours before, etc.). Every reminder is a WhatsApp template message and has a cost. Turning them off deletes nothing: when you turn them back on, the queue picks up where it left off.",
        remNoApagaConfirmacion: "⛔ Turning scheduled reminders off does NOT turn off the confirmation sent when an appointment is created (that one is controlled by the appointment's \"notify\" option), nor outbound campaigns.",
        remNoHabilitados: "Scheduled reminders are not enabled for your account",
        remNoHabilitadosDesc: "This feature is not enabled for your account. Get in touch if you want it turned on.",
        remPrendidosOk: "Scheduled reminders are going out again. The queue picks up where it left off.",
        remApagadosOk: "Scheduled reminders off. The confirmation sent when an appointment is created keeps going out.",
        asistenteTitle: "Assistant and company info",
        asistenteDesc: "Set the assistant's name and tone, and the info it answers to {{losPatientPlural}}.",
        asistenteNombre: "Assistant name",
        asistenteNombrePlaceholder: "E.g. SofIA",
        asistenteTono: "Tone",
        tonoCordial: "Cordial",
        tonoFormal: "Formal",
        tonoInformal: "Informal",
        asistenteInfoEmpresa: "Company information",
        asistenteInfoAyuda: "The assistant uses this info to answer questions (where you are, hours, {{coberturaPlural}}, etc.). Anything not here and not about the schedule, it won't make up.",
        infoDireccion: "Address",
        infoDireccionPlaceholder: "E.g. 1234 Main St, Downtown",
        infoTelefono: "Phone",
        infoTelefonoPlaceholder: "E.g. 555-1234567",
        infoHorarios: "Business hours",
        infoHorariosPlaceholder: "E.g. Mon-Fri 9am-6pm",
        infoComoLlegar: "How to get there",
        infoComoLlegarPlaceholder: "E.g. half a block from the square, entrance through the hallway",
        vocab: {
          title: "Vocabulary",
          desc: "These words are used across the whole system and in the messages the assistant sends. They are inherited from the industry template; edit only what you want to change.",
          rubroChip: "Industry",
          plural: "Plural",
          propio: "Own value",
          heredado: "Inherited",
          restaurar: "Restore industry values",
          restaurado: "Vocabulary restored to the industry values",
          scheduler: "Who schedules (front desk)",
          room: "Room / bay",
          generoTitulo: "Gender",
          generoAyuda: "Mark whether the word is masculine or feminine. English does not use it, but the other languages need it to write the article correctly.",
          generoM: "masc.",
          generoF: "fem.",
          patient: "Person served",
          professional: "Professional",
          appointment: "Appointment",
          specialty: "Specialty",
          service: "Service",
          waitingRoom: "Waiting room",
          cobertura: "Coverage (insurance / warranty)",
          patientName: "Field: Name",
          patientPhone: "Field: Phone",
        },
        infoObrasSociales: "{{coberturaPlural_c}}",
        infoObrasSocialesPlaceholder: "E.g. PAMI, OSDE, self-pay (or 'we don't take {{cobertura}}')",
        infoFormasPago: "Payment methods",
        infoFormasPagoPlaceholder: "E.g. cash, debit, transfer",
        infoAdicional: "Additional information",
        infoAdicionalPlaceholder: "Any other info the assistant should know to answer",
        grupoGeneral: "General",
        grupoRecordatorios: "Reminders",
        grupoAgenda: "Schedule",
        grupoPermisos: "Permissions & panel",
        rwTitle: "Reminder sending window",
        rwDesc: "Time range and days in which reminders are allowed to be sent.",
        rwInheritedBadge: "Inherited",
        rwOwnBadge: "Own configuration",
        rwInheritedFrom: "This company uses the TurnosIA global default. Effective value:",
        rwEffectivePreview: "Effective value",
        rwHoraDesde: "From",
        rwHoraHasta: "To",
        rwDiasEvitar: "Days to avoid",
        rwSabadoHasta: "Saturday until",
        rwSabadoPropio: "Saturday with its own time",
        rwUsarPropia: "Use own configuration",
        rwVolverHeredar: "Back to inherited",
        rwGuardar: "Save window",
        rwHelp: "Reminders that would fall outside this window or on an avoided day are moved to the nearest valid moment before it.",
        rwOkGuardado: "Sending window saved",
        rwOkHeredar: "Reverted to the global default",
        rwDia_dom: "Sun",
        rwDia_lun: "Mon",
        rwDia_mar: "Tue",
        rwDia_mie: "Wed",
        rwDia_jue: "Thu",
        rwDia_vie: "Fri",
        rwDia_sab: "Sat",
        activar: "Enable",
        configuracionGeneral: "General settings",
        parametrosDesc: "Integration parameters and module behavior.",
        urlWebhookN8n: "n8n webhook (TurnosIA)",
        urlWebhookN8nHelp: "Messages arriving on the TurnosIA line are sent to this webhook.",
        webhookConfigured: "Configured",
        webhookNotConfigured: "Not configured",
        webhookManagedBySuperadmin: "Managed by the team (superadmin panel).",
        guardarConfig: "Save settings",
        secuenciaRecordatorios: "Reminder sequence",
        secuenciaDesc: "When and what kind of message goes out beforehand. There can only be one confirmation request per {{appointment}}.",
        headerOrden: "Order",
        headerHorasAntes: "Hours before",
        headerTipo: "Type",
        headerActivo: "Active",
        headerAcciones: "Actions",
        sinPasos: "No steps configured",
        plantillasMensajes: "Message templates",
        plantillasDesc: "Texts sent in each situation. Available variables:",
        guardarPlantilla: "Save",
        especialidades: "{{specialtyPlural_c}}",
        especialidadesDesc: "How you classify who attends. You can add, edit or deactivate.",
        sinEspecialidades: "You haven't added any {{specialtyPlural}} yet.",
        cancelarEspecialidad: "Cancel",
        agregarEspecialidad: "Add {{specialty}}",
        cfTitle: "Custom fields",
        cfDesc: "Extra fields asked when booking (e.g. Plate, Notes). Your company defines them.",
        cfAdd: "Add field",
        cfEmpty: "No custom fields configured",
        cfColLabel: "Label",
        cfColType: "Type",
        cfColRequired: "Required",
        cfColCalendar: "In calendar",
        cfCalendarHelp: "Shown on the appointment card in the calendar, before the name (e.g. the license plate). Up to 2 fields.",
        cfColOrder: "Order",
        cfEdit: "Edit field",
        cfNew: "New custom field",
        cfKeyLabel: "Key",
        cfKeyHelp: "Stable identifier, no spaces. Cannot be changed later.",
        cfOptionsLabel: "Options (comma-separated)",
        cfOptionsHelp: "E.g: Red, Green, Blue",
        cfErrorLabel: "Label is required",
        cfErrorKey: "Key is required",
        cfErrorOptions: "Options are required for list type",
        cfType_text: "Text",
        cfType_textarea: "Long text",
        cfType_number: "Number",
        cfType_date: "Date",
        cfType_select: "List",
        tplTitle: "Apply industry template",
        tplDesc: "Adds specialties, fields and terms from the chosen industry. Does not overwrite what you already edited.",
        tplSelectLabel: "Industry",
        tplSelectPlaceholder: "Select...",
        tplApply: "Apply template",
        tplCurrent: "Current industry",
        tplName_generico: "Generic",
        tplName_odontologia: "Dentistry",
        tplName_taller: "Workshop",
        tplConfirmTitle: "Apply template?",
        tplConfirmBody: "Adds specialties, custom fields and terminology from the industry. Does not overwrite what you already edited.",
        tplAplicada: "Template applied",
        outgoingTitle: "TurnosIA line",
        outgoingDesc: "Number dedicated to TurnosIA. Used to send reminders and to receive the assistant's conversations.",
        outgoingLabel: "TurnosIA line",
        outgoingDefault: "Use the default connection",
        outgoingEmpty: "No WhatsApp connections in this company.",
        outgoingHint: "A QR number is recommended: TurnosIA notices are free text.",
        outgoingMetaWarn: "META requires an approved template. TurnosIA notices are free text — pick a QR number.",
        lineStatusFree: "Free",
        lineStatusCurrent: "Current TurnosIA line",
        lineStatusCompanyBot: "In use by the company bot",
        lineStatusOtherBot: "In use by another bot (own webhook)",
        lineOccupiedTitle: "This line is already in use",
        lineOccupiedCompanyBot: "This line currently serves the company bot. If you assign it to TurnosIA, incoming messages will stop going to that bot.",
        lineOccupiedOtherBot: "This line is currently used by another bot (it has its own webhook). If you assign it to TurnosIA, it will stop receiving those messages.",
        lineOccupiedConfirm: "Assign anyway",
        lineOccupiedCancel: "Cancel",
        textoPara: "Text for",
        salasEspera: "{{waitingRoomPlural_c}}",
        salasDesc: "The screens people see while they wait. Each one can show whoever you choose.",
        agregarSala: "Add room",
        sinSalas: "No rooms configured.",
        todosProfesionales: "No filter",
        featureNoHabilitada: "This feature is not enabled for your company. Contact the administrator to activate it.",
        templateBookingConfirmed: "Booking confirmation",
        templateAppointmentRescheduled: "Reschedule notice",
        templateReminder: "Simple reminder",
        templateConfirmationRequest: "Confirmation request",
        templateRebalanceOffer: "Rebalancing offer",
        templateWaitinglistOffer: "Waiting list offer",
        templateCancellationConfirmed: "Cancellation notice",
        templateWaitinglistAdded: "Added to waiting list",
        templateLlamarSiguiente: "You're up (call next)",
        templateArrivalCheck: "Are you on your way? (appointment started, no arrival)",
        arrivalTitle: "Arrival check",
        arrivalHelp: "If a confirmed appointment started a few minutes ago and nobody marked «Arrived» in the agenda, the client is asked whether they are on their way. If they reply they are here, the assistant records the arrival. Follows the scheduled reminders switch.",
        arrivalSwitch: "Ask «are you on your way?»",
        arrivalMinutes: "Minutes after the appointment start",
        arrivalMinutesHelp: "Between 5 and 120. Empty = 10.",
        arrivalWarn: "⚠ If the front desk does not mark «Arrived», the message may reach someone who is already on site.",
        errorSoloUnaConfirmacion: "There can only be one confirmation request per {{appointment}}.",
        errorNombreRequerido: "Name is required",
        errorGuardar: "Error saving",
        errorDesactivar: "Could not deactivate it",
        errorSlugRequerido: "Name and slug are required",
        slugEmpresa: "Company identifier (slug)",
        helperSlug: "No spaces or special characters",
        idDepartamento: "WAIA department ID",
        helperDepartamento: "To route tickets to this department",
        rebalanceoAuto: "Enable automatic rebalancing when cancelling appointments",
        tiempoRespuesta: "Offer response time (minutes)",
        helperTiempoRespuesta: "Minutes for the candidate to accept an offer",
        diasListaEspera: "Days on waiting list",
        helperDiasLista: "Days someone stays on the list",
        ventanaAdelantamiento: "Advance window (days)",
        helperVentana: "Days ahead to search for candidates",
        exclusionCancelar: "Exclusion after cancellation (hours)",
        helperExclusion: "Anti-loop exclusion hours",
        duracionEsperada: "Expected duration, in minutes",
        helperDuracion: "Applied when the request doesn't specify {{unService}}. Order: the chosen {{service}}; if there is no {{service}}, this one; if this is empty, 30 minutes. Also used to tell whether things are running ahead or behind.",
        vrTitle: "Booking window",
        vrDesc: "How far ahead {{appointmentPlural}} can be booked, and how soon the assistant can book them on WhatsApp.",
        vrTechoLabel: "How far ahead people can book",
        vrTechoHelp: "Maximum lead time. Applies to the panel and the assistant alike. Between {{min}} and {{max}}.",
        vrUnitLabel: "Unit",
        vrUnitDays: "days",
        vrUnitMonths: "months",
        vrPisoLabel: "Minimum lead time (WhatsApp only)",
        vrPisoHelp: "The next {{n}} days stay reserved for people who call or walk in; the assistant does not offer them, but you can still book them from here.",
        vrPisoHelpZero: "No minimum: the assistant can offer {{appointmentPlural}} for today. Set a number of days to keep the first days for people who call or walk in.",
        vrConfirmSkipLabel: "Skip the confirmation request when booked on WhatsApp under N days ahead",
        vrConfirmSkipHelp: "If {{elPatient}} booked it on WhatsApp and it is less than {{n}} days away, no confirmation is asked — they just picked it. Empty = {{n}} days.",
        vrConfirmSkipOff: "0 = always ask for confirmation, even if {{elPatient}} booked it on WhatsApp minutes ago.",
        vrBotSlotLimitLabel: "Time slots the assistant gets per query",
        vrBotSlotLimitHelp: "The assistant picks from the first {{n}} slots of each query. With several branches or sites, a low number fills up with the earliest morning slots and the afternoon never reaches it. Empty = 20.",
        pideConfirmacion: "Requires confirmation",
        recordatorio: "Reminder",
        si: "Yes",
        no: "No",
        editar: "Edit",
        eliminar: "Delete",
        editarEspecialidad: "Edit {{specialty}}",
        nuevaEspecialidad: "Add {{specialty}}",
        nombreEspecialidad: "Name",
        guardarEspecialidad: "Save",
        activa: "Active",
        inactiva: "Inactive",
        editarNombre: "Edit name",
        desactivar: "Deactivate",
        editarSala: "Edit room",
        nuevaSala: "Add {{waitingRoom}}",
        nombreSala: "Name *",
        slugSala: "Slug *",
        helperSlugSala: "Lowercase and hyphens only. Example: main-room",
        plantillaVoz: "Voice template",
        helperVoz: "Variables: {nombre} {consultorio} {profesional}",
        guardarSala: "Save",
        copiarUrl: "Copy URL",
        sinLinkCorto: "No short link",
        regenerarLink: "Regenerate and copy short link",
        generarLink: "Generate short link",
        linkCopiado: "Link copied",
        errorLink: "Error generating short link",
        editarPaso: "Edit step",
        agregarPaso: "Add step",
        horasAntes: "Hours before",
        tipoRecordatorio: "Type",
        activoSwitch: "Active",
        guardarPaso: "Save",
        guardadoOk: "Saved successfully",
        permisosProfesional: "Permissions for whoever attends",
        permisosProfesionalDesc: "What they can do on their own agenda, from their calendar.",
        professionalCanCreate: "Can book {{appointmentPlural}} in their own agenda",
        professionalCanMove: "Can reschedule (move or drag) their own",
        panelDeTurno: "Detail panel",
        panelDeTurnoDesc: "Which actions show up when you open the detail.",
        panelAction: {
          status: "Change status",
          move: "Move",
          reAvisar: "Notify again via WhatsApp",
          cancelReason: "Cancel with reason",
          openChat: "Open the chat",
          history: "History",
          statusLog: "Status change log",
          waitingRoom: "Call ({{waitingRoom}})",
          followUp: "Follow-up",
          note: "Notes",
          showPhone: "Show phone",
          delete: "Delete",
        },
        localizacion: "Localization",
        localizacionDesc: "Time zone and date/time language for the whole company.",
        timezone: "Time zone",
        locale: "Date language",
      },
      internalChat: {
        placeholder: "Write a message...",
        para: "To",
        todos: "All",
        chatInterno: "Internal chat",
        mediaTooLarge: "The files exceed the 18 MB limit. Send fewer at a time.",
        quotedNotLoaded: "The quoted message is no longer loaded in this conversation.",
        jumpToQuoted: "Go to the quoted message",
      },
      salaEspera: {
        cargando: "Loading…",
        errorConexion: "Could not connect to the service.",
        fallbackNombre: "{{waitingRoom_c}}",
        enAtencion: "⬤ Currently being attended",
        aguardando: "Waiting to be called…",
        proximosTurnos: "Coming up",
        sinProximos: "Nobody is waiting",
        yaAtendidos: "Already seen",
        sinPrevios: "Nobody has been seen yet today",
        linkNoEncontrado: "We couldn't find that screen",
        llamado: "Called",
        enAtencionCard: "In progress",
        min: "min",
      },
      sidebar: {
        empresas: "Companies",
        dashboardAdmin: "Dashboard",
        comunicados: "Announcements",
        logsDelSistema: "System logs",
        avisos: "Notices",
        apis: "APIs",
        turnosIA: "TurnosIA",
        citas: "Appointments",
        changelog: "Changelog",
        turnos: "TurnosIA",
        pendientes: "Pending",
        estadisticas: "Statistics",
        reportes: "Reports",
        etiquetas: "Tags",
        estadosDeContacto: "Contact Statuses",
        matchprop: "MatchProp",
        aiServices: "AI Services",
        aiStats: "AI Statistics",
        connectionsOverview: "Connections (global)",
      },
      superAdminConnections: {
        qrSection: "QR lines — group health",
        qrHelp: "Counts, since the server last started, group messages that came in and those that could not be decrypted. If a line says it is connected but does not receive its groups, it shows in red. WAIA does not reconnect it on its own: disconnect it and scan the QR again from Connections.",
        qrEmpty: "No QR lines.",
        qrGroups: "Groups",
        qrGroupOk: "Group OK",
        qrGroupFail: "Group not decrypted",
        qrDirectOk: "Direct OK",
        qrLastGroup: "Last group message",
        qrResync: "Group resync",
        qrResyncCount: "{{count}} groups",
        qrResyncError: "Error: {{error}}",
        qrPrior: "Group messages in the 24 h before startup: {{count}}",
        qrStatus: {
          ok: "OK",
          sin_datos: "No data yet",
          grupos_sin_descifrar: "Groups not decrypting",
          grupos_callados: "Groups silent",
        },
        title: "Connections by company",
        subtitle: "Status of every WhatsApp connection and Meta line health, across all companies.",
        refresh: "Refresh",
        semaphoreSection: "Connections traffic light",
        semaphoreHelp: "Summary per company. Green: all connected. Yellow: reconnecting or partial outage. Red: down with no active connection. Grey: no connections.",
        company: "Company",
        state: "State",
        total: "Total",
        connected: "Connected",
        transitional: "Transitioning",
        down: "Down",
        lastChange: "Last change",
        semaphore: {
          green: "Operational",
          yellow: "Attention",
          red: "Down",
          none: "No connections",
        },
        metaSection: "Meta lines",
        metaHelp: "Health of each WhatsApp Cloud API / Coexistence line.",
        metaEmpty: "No Meta lines configured.",
        line: "Line",
        type: "Type",
        coexistence: "Coexistence",
        phoneNumberId: "Phone Number ID",
        wabaId: "WABA ID",
        status: "Status",
        health: "Health",
        historySync: {
          title: "History",
          attempts: "{{count}} attempt(s)",
          requestedAt: "Onboarded: {{date}}",
          nextAt: "Next retry: {{date}}",
          lastError: "Last error: {{error}}",
          notSharedAt: "Meta notice: {{date}}",
          status: {
            pending: "Pending",
            success: "Requested",
            failed: "Failed",
            expired: "Expired",
            skipped: "Not requested",
            not_shared: "Client did not share history",
          },
        },
      },
      superAdminAI: {
        title: "AI Services — Per-company configuration",
        subtitle: "Enable AI Services per company and load provider keys (OpenAI, Anthropic, Gemini) as a fallback.",
        company: "Company",
        selectCompany: "Select company",
        enabled: "Enable AI Services",
        enabledHelp: "Activates the AI Services section for this company. The admin will be able to configure services and their keys.",
        keysSection: "Provider keys (fallback)",
        keysHelp: "The admin's keys take priority. These are an optional fallback.",
        providerEnabled: "enabled",
        apiKey: "{{provider}} key",
        keyConfigured: "•••• (configured)",
        keyNotSet: "Not configured",
        save: "Save",
        saveOk: "Configuration saved",
        showKey: "Show key",
        hideKey: "Hide key",
      },
      aiServices: {
        title: "AI Services",
        notEnabled: "AI Services is not enabled for your company. Contact support.",
        transcriptLabel: "Transcript",
        transcribeBtn: "Transcribe audio",
        transcribing: "Transcribing…",
        failedMsg: "Could not transcribe",
        retry: "Retry",
        consumptionWarning: "⚠ AI services consume tokens from your keys. Each use (for example, transcribing an audio) is billed to your provider account.",
        keysSection: "AI keys",
        keysHelp: "Load your own keys per provider. It's your spend: calls are billed to these keys.",
        apiKey: "{{provider}} key",
        keyConfigured: "•••• (configured)",
        keyNotSet: "Not configured",
        servicesSection: "Services",
        provider: "Provider",
        model: "Model",
        mode: "Mode",
        modeHuman: "Mode (human-attended)",
        aiAttendedMode: "AI-attended",
        aiAttendedSiempre: "Always transcribe",
        aiAttendedNunca: "Never transcribe",
        aiAttendedHelp: "When the AI attends the chat, sets whether the audio is turned into text so the AI can understand it.",
        limitSection: "Anti-abuse limit",
        limitHelp: "0 = no limit. Applies only to automatic transcription; the manual button is never limited.",
        maxPerWindow: "Max. audios per contact",
        windowMinutes: "every (minutes)",
        notSupported: "not supported",
        transcribeProviderTip: "Anthropic does not support audio transcription. Use OpenAI or Gemini.",
        modes: {
          auto: "Automatic (always)",
          a_pedido: "On demand (manual)",
          nunca: "Never",
        },
        transcription: {
          title: "Audio transcription",
          help: "Converts incoming audios into text. Choose provider, model and when to transcribe.",
        },
        save: "Save",
        saveOk: "Saved",
        showKey: "Show key",
        hideKey: "Hide key",
      },
      superAIStats: {
        title: "AI Assistant Statistics — Settings",
        company: "Company",
        selectCompany: "Pick a company",
        enabled: "Module enabled",
        enabledHelp:
          "When off, the module is hidden from the admin menu and serves no data.",
        visibilityTitle: "Panel visibility",
        visibilityHelp:
          "Choose which panels the client sees. Cannot be configured while the module is off.",
        panels: {
          horasAhorradas: "Hours saved",
          cobertura: "24/7 coverage",
          reclamosATiempo: "Complaints on time",
          iaVsHumano: "AI vs human",
          recomendaciones: "Recommendations",
          embudoKpis: "Funnel & KPIs",
          objetoReclamo: "Complaint subject",
          tags: "Tags",
        },
        saveCompany: "Save company",
        saveOk: "Settings saved",
        saving: "Saving…",
        assistantsTitle: "Assistants",
        noAssistants: "This company has no assistants yet.",
        catalogName: "Catalog name",
        displayName: "Display name",
        type: "Type",
        types: {
          satisfaccion: "Satisfaction",
          venta: "Sales",
          recupero: "Recovery",
        },
        technicalConfig: "Technical config",
        tech: {
          humanClosingHour: "Human closing hour",
          humanWorkMarginHours: "Work margin (hrs)",
          timeoutHours: "Timeout (hrs)",
          sinRespuestaWarnPct: "No-response threshold (0-1)",
          queueRoles: "Queue roles (JSON)",
          jsonFieldMap: "Field map (JSON)",
        },
        saveAssistant: "Save assistant",
        saveAssistantOk: "Assistant saved",
        invalidJson: "Invalid JSON in queue roles or field map.",
      },
      superMatchProp: {
        title: "MatchProp — Per-company configuration",
        subtitle: "Property request detector for WhatsApp groups. Configure inventory, LLM and test mode per company.",
        company: "Company",
        selectCompany: "Select company",
        enabled: "Enable MatchProp",
        enabledHelp: "Turns on group monitoring and alert generation for this company.",
        dryRun: "Test mode (dry-run)",
        dryRunHelp: "In test mode, alerts show a TEST badge and are not treated as real sends.",
        llmSection: "Language model (LLM)",
        llmProvider: "Provider",
        llmModel: "Model",
        llmKey: "LLM API key",
        inventorySection: "Inventory",
        inventorySource: "Inventory source",
        tokkoKey: "Tokko API key",
        gvaId: "Agency ID (GVA)",
        gvaToken: "GVA token",
        gvaHelp: "The GVA credential (ID + token) is provided by the vendor, not the client.",
        ttlMinutes: "Inventory TTL (minutes)",
        keyConfigured: "•••• (configured)",
        keyNotSet: "Not set",
        lastSync: "Last sync",
        save: "Save",
        forceSync: "Force update now",
        saveOk: "Configuration saved",
        syncOk: "Synced {{count}} properties",
        showKey: "Show key",
        hideKey: "Hide key",
      },
      matchpropAdmin: {
        title: "MatchProp",
        notEnabled: "MatchProp is not enabled for your company. Contact support.",
        groupsSection: "Groups to monitor",
        groupsHelp: "Choose which groups MatchProp should scan for requests.",
        noGroups: "No known WhatsApp groups yet.",
        groupOn: "Group enabled",
        groupOff: "Group disabled",
        tolerancesSection: "Match tolerances",
        dormsPlus: "Extra bedrooms allowed",
        dormsPlusHelp: "Accept properties with up to X MORE bedrooms than requested.",
        dormsMinus: "Fewer bedrooms allowed",
        dormsMinusHelp: "Accept properties with up to X FEWER bedrooms than requested.",
        precioMargin: "Price margin (%)",
        precioMarginHelp: "Accept properties up to X% over budget.",
        topN: "Matches per alert",
        topNHelp: "How many matches to show in each alert.",
        minTopLevel: "Minimum level to alert",
        minTopLevelHelp: "EXACT only alerts exact matches; SIMILAR includes approximate ones.",
        levelExact: "EXACT",
        levelSimilar: "SIMILAR",
        save: "Save",
        saveOk: "Saved",
        aiSection: "Artificial Intelligence",
        llmProvider: "AI provider",
        llmModel: "Model",
        llmKey: "AI API key",
        comingSoon: "coming soon",
        sourceSection: "Inventory source",
        sourceLabel: "Source",
        sourceNotSet: "Your provider has not configured the inventory source yet.",
        crmKey: "CRM API key",
        gvaId: "Agency ID (GVA)",
        gvaToken: "GVA token",
        gvaHelp: "Credential provided by GVA.",
        keyConfigured: "•••• (configured)",
        keyNotSet: "Not set",
        showKey: "Show key",
        hideKey: "Hide key",
        consumptionWarning: "⚠ Enable MatchProp only on property REQUEST groups. Every message in a monitored group is analyzed with AI and consumes your API tokens. Enabling non-request groups wastes spend.",
        confirmTitle: "Confirm group monitoring",
        confirmBody: "Group \"{{group}}\" will be analyzed with AI on every message, consuming your tokens. Confirm?",
        cancel: "Cancel",
        confirm: "Enable",
      },
      tags: {
        titulo: "Tags",
        nueva: "New tag",
        creada: "Tag created",
        eliminada: "Tag deleted",
        nombre: "Name",
        color: "Color",
        vistaPrevia: "Preview",
        cancelar: "Cancel",
        crear: "Create",
        headerColor: "Color",
        headerNombre: "Name",
        headerAcciones: "Actions",
        sinEtiquetas: "No tags",
      },
      stats: {
        titulo: "Statistics & ROI",
        ticketsHoy: "Tickets today",
        ticketsSemana: "Tickets this week",
        ticketesMes: "Tickets this month",
        tiempoRespuesta: "Average response time",
        impactoIA: "AI impact this month",
        horasAhorradas: "{{hours}} hours saved",
        equivalente: "Equivalent to {{days}} working days · {{ai}} messages answered by AI vs {{human}} by humans",
        conversacionesPorDia: "Conversations per day (last 30 days)",
        mensajesIAvsHumano: "Messages: AI vs Human",
        sinDatos: "No data yet",
        tickets: "Tickets",
        fecha: "Date",
        ia: "AI",
        humano: "Human",
      },
      contactStates: {
        entryStage: {
          help: "Funnel entry stage: contacts without a stage show up here. Choose only one (the column that receives new conversations).",
          radio: "Use as Funnel entry stage",
          radioSelected: "Funnel entry stage (click to remove)",
          radioDisabled: "Only an active stage can be the Funnel entry stage",
          badge: "Funnel entry",
          setOk: "Entry stage updated",
          clearedOk: "The Funnel no longer has an entry stage",
        },
        crmSwitch: {
          title: "Funnel",
          label: "Enable Funnel",
          desc: "Shows contacts in stages (columns by state) and lets you move them by dragging. It appears in the menu for the whole team.",
          needsActive: "Enable at least one state to turn the Funnel on.",
          lastActiveTitle: "Disabling the last state",
          lastActiveText: "The Funnel is on and this is the last active state. If you disable it, the Funnel will be unavailable until you enable another state.",
          lastActiveConfirm: "Disable anyway",
          enabledOk: "Funnel enabled",
          disabledOk: "Funnel disabled",
        },
        titulo: "Contact Statuses — Admin",
        estadosContacto: "Contact Statuses",
        agregarEstado: "Add status",
        motivosPerdida: "Loss Reasons",
        agregarMotivo: "Add reason",
        noHayMotivos: "No loss reasons. Add one to display it when marking a contact as Lost.",
        cierreAutomatico: "Automatic Ticket Closure",
        cerrarGanado: "Close ticket when marked as Won",
        descCerrarGanado: "When a contact is marked as Won, the active ticket is automatically closed.",
        cerrarPerdido: "Close ticket when marked as Lost",
        descCerrarPerdido: "When a contact is marked as Lost, the active ticket is automatically closed.",
        guardarConfig: "Save settings",
        sistema: "System",
        desactivar: "Deactivate",
        activar: "Activate",
        subir: "Move up",
        bajar: "Move down",
        editar: "Edit",
        eliminar: "Delete",
        noEliminarSistema: "Cannot delete a system status",
        ocultarSistema: "System status. You can hide it but not delete it.",
        editarEstado: "Edit status",
        nuevoEstado: "New status",
        editarMotivo: "Edit reason",
        nuevoMotivo: "New loss reason",
        nombre: "Name",
        cancelar: "Cancel",
        guardar: "Save",
        nombreObligatorio: "Name is required",
        estadoActualizado: "Status updated",
        estadoCreado: "Status created",
        estadoEliminado: "Status deleted. Assigned contacts are now without a status.",
        motivoActualizado: "Reason updated",
        motivoCreado: "Reason created",
        motivoEliminado: "Reason deleted",
        configuracionGuardada: "Settings saved",
        confirmarEliminacion: "Confirm deletion",
        eliminarEstado: "Delete this status? Contacts with this status will be left without an assigned status.",
        eliminarMotivo: "Delete this loss reason?",
      },
      pendingDashboard: {
        titulo: "Pending Dashboard",
        actualizar: "Refresh",
        actualizadoAt: "Updated {{hora}}",
        mios: "Mine",
        vencidos: "Overdue",
        hoy: "Today",
        proximos7d: "Next 7 days",
        sinFecha: "No date",
        totalActivos: "Total active",
        ver: "View",
        soloMios: "Mine only",
        miEquipo: "My team",
        todos: "All",
        asesor: "Agent",
        motivo: "Reason",
        limpiarFiltros: "Clear filters",
        sinPendientesGrupo: "No pending items in this group",
        sinAsignar: "Unassigned — team",
        asignadoA: "Assigned to: {{name}}",
        ultimaAccion: "Last action: {{name}} · {{date}}",
        tomar: "Take",
        reprogramar: "Reschedule",
        resolver: "Resolve",
        chat: "Chat",
        asignarmeEste: "Assign this to me",
        marcarResuelto: "Mark as resolved",
        irAlChat: "Go to chat",
        pendienteResuelto: "Pending resolved",
        pendienteReprogramado: "Pending rescheduled",
        pendienteAsignado: "Pending assigned to you",
        reprogramarTitulo: "Reschedule pending",
        cuando: "When?",
        fechaYHora: "Date and time",
        cancelar: "Cancel",
        guardar: "Save",
        sinFechaChip: "no date",
        sinResponsable: "no assignee",
        vencidoText: "overdue",
        venceText: "due",
        hoyText: "today",
        proximos7dias: "Next 7 days",
        sinFechaGrupo: "No date",
      },
      reports: {
        titulo: "Reports",
        desde: "From",
        hasta: "To",
        agente: "Agent",
        todos: "All",
        cola: "Queue",
        todas: "All",
        motivoContacto: "Contact reason",
        generar: "Generate",
        exportarCSV: "Export CSV",
        totalChats: "Total chats",
        cerrados: "Closed",
        enAtencion: "In progress",
        esperando: "Waiting",
        sinRespuesta: "No reply",
        respPromedio: "Avg. response",
        chatsPorDia: "Chats per day",
        chats: "Chats",
        fecha: "Date",
        estadoChats: "Chat status",
        sinDatos: "No data",
        chatsPorAgente: "Chats by agent",
        chatsPorCola: "Chats by queue",
        pctTotal: "% of total",
        chatsPorMotivo: "Chats by contact reason",
        motivo: "Reason",
        ia: "AI",
        humano: "Human",
        abiertos: "Open",
        pendientes: "Pending",
        mensajesIAvsHumano: "Messages: AI vs Human",
      },
      contacts: {
        title: "Contacts",
        toasts: { deleted: "Contact deleted successfully!" },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage: "Are you sure you want to delete this contact? All related chats will be lost.",
          importMessage: "Do you want to import all contacts from your phone?",
        },
        buttons: {
          import: "Import contacts",
          add: "Add contact",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
        tabContactos: "Contacts",
        tabClientes: "Contacts",
        tabPendientes: "Pending",
        tabDescartados: "Discarded",
        tabTodos: "All",
        colNombreWA: "WhatsApp name",
        colTipoCliente: "Client type",
        colNumero: "Number",
        colEmpresa: "Company",
        colNotas: "Notes",
        colAtendidoPor: "Attended by",
        colTotalChats: "Total chats",
        colUltimaActividad: "Last activity",
        sinNombre: "No name",
        moveTo_qualified: "Contacts",
        moveTo_pending: "Pending",
        moveTo_disqualified: "Discarded",
        movedToast: "Contact moved to {{tab}}",
        undoButton: "Undo",
        menuMoveTo_qualified: "Move to Contacts",
        menuMoveTo_pending: "Move to Pending",
        menuMoveTo_disqualified: "Move to Discarded",
        importando: "Importing contacts in the background...",
        importOk: "Imported {{imported}} contacts. {{skipped}} already existed.",
        importDone: "Import completed.",
      },
      queueModal: {
        title: { add: "Add queue", edit: "Edit queue" },
        form: { name: "Name", color: "Color", greetingMessage: "Greeting Message" },
        buttons: { okAdd: "Add", okEdit: "Save", cancel: "Cancel" },
        signatureRule: "Signature rule",
      },
      userModal: {
        title: { add: "Add user", edit: "Edit user" },
        form: { name: "Name", email: "Email", password: "Password", profile: "Profile", whatsapp: "Default Connection", canSeeUnassigned: "See unassigned chats", canViewPhones: "Can view phone numbers", canViewPhonesHelper: "If off, this user sees contact phone numbers masked (e.g. +549351●●●●482). Administrators always see them in full.", allowedWhatsapps: "Allowed connections", allowedWhatsappsAll: "All connections", allowedWhatsappsHelp: "If none selected, the user will see chats from all connections." },
        buttons: { okAdd: "Add", okEdit: "Save", cancel: "Cancel" },
        success: "User saved successfully.",
        signatureSectionTitle: "Message signature",
        signatureEnabledLabel: "Enable personal signature",
        signatureNameLabel: "Display name for signature (optional)",
        signatureNameHelp: "If empty, your regular user name is used.",
        showName: "Include name",
        showDepartment: "Include department (ticket queue)",
        showCompany: "Include company",
        signaturePreviewLabel: "Preview:",
        signaturePreviewDept: "[Department]",
        signaturePreviewCompany: "[Company]",
        signaturePreviewEmpty: "(no components selected — equivalent to not signing)",
        signaturePreviewDisabled: "(signature disabled)",
        signatureSanitizedWarning: "Special characters (* _ ~ `) were removed from your signature. These characters break the format and are not allowed.",
        chipsVisibility: {
          title: "Ticket statistics and data",
          subtitle: "Show or hide the information that appears on each ticket in the list",
          attentionTime: {
            label: "Response time (TDR)",
            tooltip: "How long the customer has been waiting for our reply",
          },
          clientSilence: {
            label: "Time without a customer reply",
            tooltip: "Time since our last reply without the customer writing back",
          },
          ticketAge: {
            label: "Ticket age",
            tooltip: "Total time the ticket has been open",
          },
          expiration: {
            label: "Expiration",
            tooltip: "Tickets close to automatic closure",
          },
          contactState: {
            label: "Contact status",
            tooltip: "Commercial status of the contact (New, Won, Customer, etc.)",
          },
          whatsappLine: {
            label: "WhatsApp line",
            tooltip: "WhatsApp connection through which the ticket arrived",
          },
          contactType: {
            label: "Customer type",
            tooltip: "Category assigned to the contact",
          },
          queue: {
            label: "Department",
            tooltip: "Queue or department assigned to the ticket",
          },
          tags: {
            label: "Tags",
            tooltip: "Tags applied to the ticket",
          },
        },
      },
      chatConnectionBar: {
        windowOpen: "Window open",
        closesIn: "closes in {{time}}",
        windowClosed: "Window closed",
      },
      messagesInput: {
        placeholderOpen: "Type a message or press ''/'' to use the registered quick responses",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        metaWindowClosedPlaceholder: "24h window closed — start with a template to message them.",
        signMessage: "Sign",
        includeName: "Include name",
        captionPlaceholder: "Add a caption...",
        cancelMedia: "Cancel",
        sendMedia: "Send",
        dropFileHere: "Drop file here",
        lockReason: {
          company_disabled: "Signature is disabled in company settings.",
          contact_forced: "This contact is configured to always sign.",
          contact_blocked: "This contact is configured to never sign.",
          type_forced: "Contact type is configured to always sign.",
          type_blocked: "Contact type is configured to never sign.",
          queue_forced: "Ticket queue is configured to always sign.",
          queue_blocked: "Ticket queue is configured to never sign.",
        },
      },
      scheduledMessages: {
        mode_button: "Schedule send",
        queue_hint: "Queued messages",
        max_reached: "Maximum 4 messages per scheduled send",
        pick_datetime: "When to send?",
        send_anyway_label: "Send even if the contact replies",
        badge: "Scheduled for {{datetime}}",
        cancelled_reply: "Scheduled send cancelled: contact replied",
        cancelled_manual: "Scheduled send cancelled",
        cancel_action: "Cancel scheduled message",
        sent_ok: "Scheduled message sent",
        send_failed: "Could not send the scheduled message",
        cancel: "Cancel",
        invalid_past: "Date and time must be in the future",
        was_scheduled: "Sent as scheduled message",
        sending: "Sending…",
        trace_by: "Scheduled by {{name}}",
        trace_anon: "Scheduled",
        trace_for: "for {{datetime}}",
        event_cancelled_manual: "Scheduled send cancelled by the operator",
        event_cancelled_reply: "Scheduled send cancelled: the contact replied",
        event_cancelled_closed: "Scheduled send cancelled: the ticket was closed",
        event_cancelled_notfound: "Scheduled send cancelled: the ticket no longer exists",
        event_failed: "Could not send the scheduled message",
        event_failed_window: "Could not send: the 24 h window expired",
        event_failed_partial: "{{sent}} of {{total}} sent — the rest could not be sent",
      },
      signatureOnboarding: {
        message: "Your company has message signatures enabled. Configure your personal signature to better identify yourself with your clients.",
        configure: "Configure",
        dismiss: "Dismiss",
      },
      contactModal: {
        title: { add: "Add contact", edit: "Edit contact" },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          numberHelp: "Digits only, with country code. E.g.: 5493513456789",
          numberOnlyDigits: "Only digits are allowed.",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
          lastName: "Last name",
          whatsappName: "WhatsApp name",
          company: "Company",
          kind: "Customer type",
          notes: "Notes",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
        statusSection: "Contact status",
        moveTo_qualified: "Contacts",
        moveTo_pending: "Pending",
        moveTo_disqualified: "Discarded",
        movedToast: "Contact moved to {{tab}}",
        signatureMode: "Signature mode",
        signatureModeDefault: "Default (user or type rules decide)",
        signatureModeAlways: "Always sign with this contact",
        signatureModeNever: "Never sign with this contact",
      },
      contactTypeModal: {
        title: "Edit contact type",
        name: "Name",
        color: "Color",
        signatureRule: "Signature rule",
        cancel: "Cancel",
        save: "Save",
        savedOk: "Contact type updated",
        errNameRequired: "Name is required",
      },
      deleteMessageModal: {
        title: "Do you want to delete this message?",
        forEveryone: "Delete for everyone",
        forMe: "Delete for me",
        cancel: "Cancel",
        revokeFallbackToast: "The message could not be deleted for everyone. It was deleted only for you.",
      },
      settingsExtra: {
        // feat_347 — labels de los 8 tabs de /Settings
        // feat_352 — se fue `tabIa` (el tab se fusionó en automatizaciones) y entró
        // `tabReporteEmail`. Siguen siendo 8.
        tabNegocio: "Business",
        tabBandeja: "Inbox",
        tabMensajes: "Messages",
        tabAutomatizaciones: "Automations",
        tabReporteEmail: "Email report",
        tabClasificacion: "Classification",
        tabIntegraciones: "Integrations & API",
        tabPermisos: "Permissions",
        // feat_351 — tab Permisos restyleado con el patrón visual canónico
        permisosSectionTitle: "Advisor permissions",
        permisosSectionHelp: "Choose what an advisor — any user who is not an administrator — can do in chats. Administrators always have every permission.",
        permisosDeleteChatLabel: "Allow deleting chats",
        permisosDeleteChatHelp: "Advisors can delete a whole chat from the chat menu.",
        permisosDeleteChatTooltip: "Deletes the entire chat, with all of its messages, for the whole company. This cannot be undone.",
        permisosDeleteMessageLabel: "Allow deleting messages",
        permisosDeleteMessageHelp: "Advisors can delete individual messages inside a chat.",
        permisosDeleteMessageTooltip: "Deletes a message from the chat history. If the company sent it and WhatsApp still allows it, deleting it for the customer is offered too.",
        moreInfoAriaLabel: "More information",
        // feat_339 — gate de carga de la página de Ajustes
        loadingSettings: "Loading…",
        identidadAsistente: "Assistant Identity",
        // feat_353 — restyle del tab Negocio con el patrón de feat_351
        negocioIdentidadHelp: "How the AI introduces itself and what it says about your business.",
        negocioSedeLabel1: "Location 1",
        negocioSedePh1: "E.g. Main office (346 Main St.)",
        negocioSedeLabel2: "Location 2",
        negocioSedePh2: "E.g. North branch",
        negocioHorarioHelp: "Base schedule used by abandoned cart and the other automations.",
        negocioAlways247Help: "The business is always considered available.",
        negocioFeriadosHelp: "Days the business is closed, even if the schedule says otherwise.",
        nombreNegocio: "Business name",
        phNombreNegocio: "E.g.: Gazzera Dental Practice",
        nombreAsistente: "Virtual assistant name",
        phNombreAsistente: "E.g.: Lucy",
        idioma: "Language",
        tonoAsistente: "Assistant tone",
        tokenAPI: "API Token",
        usarTokenDesc: "Use this token to connect WAIA with external systems.",
        ocultarToken: "Hide token",
        mostrarToken: "Show token",
        copiarToken: "Copy token",
        tokenCopiado: "Token copied",
        integracionIA: "Integration / AI",
        guardarConfig: "Save settings",
        iaHabilitada: "AI enabled",
        vendedorIA: "AI Agent",
        activo: "Active",
        inactivo: "Inactive",
        deshabilitadoAdmin: "Disabled by administrator",
        automatizacionTickets: "Ticket automation",
        escenario1: "Scenario 1: Abandoned cart",
        descEscenario1: "The agent or AI sent the last message, but the client did not reply. The AI is notified via webhook for follow-up.",
        escenario2: "Scenario 2: Unattended",
        descEscenario2: "The client sent the last message but the team has not replied. An internal note is added to the ticket to alert the assigned agent.",
        escenario3: "Scenario 3: Forgotten ticket",
        descEscenario3: "The agent or AI sent the last message, the ticket has an assigned agent and has been open too long. The ticket is automatically closed with an internal note.",
        activar: "Enable",
        umbralHoras: "Inactivity threshold (hours)",
        rec4h: "Recommended: 4 hours",
        rec2h: "Recommended: 2 hours",
        rec24h: "Recommended: 24 hours",
        configClasica: "Classic configuration (close by general inactivity)",
        activarResolucion: "Enable automatic resolution by inactivity",
        resolverEn: "Resolve after (hours of inactivity)",
        ticketsSinActividad: "Tickets without activity for this long will be closed",
        notificarCliente: "Notify client (minutes before closing)",
        sinNotificacion: "0 = no notification before closing",
        mensajeDespedida: "Farewell message to client",
        phMensajeDespedida: "Hello, your inquiry has been closed due to inactivity. You can write to us any time.",
        enviarAnteCierre: "Sent to the client before closing the ticket",
        notificarIA: "Notify AI system when closing (to capture context)",
        continuidadConversacion: "Conversation continuity",
        descContinuidad: "Defines how many days after a ticket is closed it can be reopened if the client writes again. With 0 days, the conversation is never fragmented: it is always the same ticket.",
        diasReapertura: "Reopening days",
        tdrTitle: "Response Time Indicator (TDR)",
        tdrDesc: "Defines alert thresholds for client wait time. The indicator changes color based on the time elapsed since the client's last message without a team reply.",
        tdrAmarilla: "Yellow alert (minutes)",
        tdrAmarillaDesc: "The indicator turns yellow when the client has been waiting this long without a reply.",
        tdrRoja: "Red alert (minutes)",
        tdrRojaDesc: "The indicator turns red when the client has been waiting this long without a reply.",
        tdrWarning: "⚠️ The yellow threshold must be lower than the red threshold.",
        tiposCliente: "Client Types",
        nombreTipo: "Type name",
        sinTipos: "No types defined",
        agregar: "Add",
        motivosContacto: "Contact Reasons",
        nombreMotivo: "Reason name",
        sinMotivos: "No reasons defined",
        copiar: "Copy",
        copiado: "Copied!",
        urlAutomatizacion: "Automation URL",
        tokenAutomatizacion: "Automation Token",
        timeoutSegundos: "Timeout (seconds)",
        reintentos: "Retries",
        promptAsistente: "Assistant Prompt",
        firmaTitle: "Message signature",
        firmaEnabledLabel: "Enable signature for this company",
        firmaEnabledHelp: "When active, users can sign their outgoing messages with their name, department and/or company. Each user configures their personal signature in their profile.",
        firmaReglaNoneOption: "No rule (user decides)",
        firmaReglaAlwaysOption: "Always sign",
        firmaReglaNeverOption: "Never sign",
        firmaReglaPreferOnOption: "Suggest signing (switch defaults ON)",
        firmaReglaPreferOffOption: "Suggest not signing (switch defaults OFF)",
        firmaQuoteLabel: "Quote style for signature",
        firmaQuoteHelp: "If active, the signature is sent as a WhatsApp quote block (green indented) to stand out from the message.",
        inboxModeSectionTitle: "Inbox mode",
        inboxModeLabel: "Inbox mode",
        inboxModeHelper: "Unified shows ATTENDING and WAITING in a single list ordered by activity.",
        inboxModeSplit: "Split (two sub-tabs)",
        inboxModeUnified: "Unified (WhatsApp style)",
        inboxOpenCount: "Attending",
        inboxPendingCount: "Waiting",
        inboxOpenTooltip: "Chats with an assigned agent",
        inboxPendingTooltip: "Chats waiting to be attended",
        inboxModeSmart: "Smart (orphans in Waiting)",
        inboxSmartAttendingTooltip: "Chats being attended + assigned by AI",
        inboxSmartWaitingTooltip: "Chats without assigned department — require human attention",
        inboxSortLabel: "Order",
        inboxSortChrono: "Chronological",
        inboxSortUrgent: "Urgent first",
        inboxUnansweredLabel: "Unanswered",
        inboxUnansweredTooltip: "Shows only chats where the client wrote and nobody has responded yet",
        inboxUnansweredActive: "Filtering: unanswered",
        cancelScheduledOnReplyLabel: "Cancel scheduled messages if contact replies",
        markReadOnOpenSectionTitle: "Message reading",
        markReadOnOpenLabel: "Mark as read when opening the chat",
        markReadOnOpenHelper: "When enabled, messages are marked as read as soon as the advisor opens the chat. When disabled, they are only marked when a reply is sent.",
        showUserFilterSectionTitle: "User filter in ticket list",
        showUserFilterLabel: "Show user filter (admins only)",
        showUserFilterHelper: "Allows admins to filter the ticket list by one or more assigned agents.",
        attendingModeSectionTitle: "Attended by (indicator and lock)",
        attendingModeLabel: "Mode",
        attendingModeOff: "No indicator",
        attendingModeVisual: "Show who is attending",
        attendingModeLock: "Show and lock writing to others' tickets",
        attendingModeHelper: "\"Show who is attending\" adds an \"ATTENDED BY\" indicator in the header and the list when an open ticket belongs to another advisor. \"Lock writing to others' tickets\" also prevents writing in that ticket. The ticket owner and administrators can always write; unassigned pending tickets stay open to anyone.",
        closedPooledSectionTitle: "Shared resolved chats (who can pick them up)",
        closedPooledLabel: "Mode",
        closedPooledOff: "Isolated (everyone sees only their own)",
        closedPooledQueue: "Resolved chats shared within the queue",
        closedPooledCompany: "Resolved chats shared across the whole company",
        closedPooledHelper: "A resolved chat stays in the Resolved tab of whoever resolved it. This mode decides who ELSE can find it with the search and pick it up: nobody (isolated), advisors in the same queue, or anyone in the company. Picking it up moves it to IN PROGRESS, assigns it to whoever took it and moves it to their queue. While a person is handling it, the AI does not reply.",
        // feat_339 — desglose por modo, debajo de la intro de arriba
        closedPooledHelperOff: "Nobody else sees it. Each advisor only finds the chats they resolved themselves.",
        closedPooledHelperQueue: "Advisors who share that queue can see it. Picking it up moves it to the queue of whoever took it.",
        closedPooledHelperCompany: "Anyone in the company sees it, whatever the queue. Ideal when a customer comes back and whoever is free takes over.",
        // feat_343 — Resolver directo (cierra sin preguntar en qué quedó)
        directResolveSectionTitle: "Direct resolve",
        directResolveLabel: "When resolving a chat, close it right away — without asking how it ended",
        directResolveHelper: "With the switch off, tapping Resolve asks whether the contact was won or lost. With the switch on, Resolve closes the chat straight away and the contact's state stays as it is.",
        outboundTypingSectionTitle: "\"Typing...\" indicator",
        outboundTypingLabel: "Show \"typing...\" / \"recording audio...\" to the contact",
        outboundTypingHelp: "When an agent types or records audio, the contact sees it on their phone (like WhatsApp). Supported connections only; Meta shows \"typing\" only and requires a recent message from the contact.",
        outboundTypingAiLabel: "Show \"typing...\" when the AI replies",
        outboundTypingAiHelp: "While the AI generates a reply, the contact sees \"typing...\" on their phone. Makes the wait feel natural.",
        autoReplyMediaSectionTitle: "Auto-reply to incoming media",
        autoReplyMediaEnabledLabel: "Send a polite reply when contacts send audio, video, images or documents",
        autoReplyMediaEnabledHelp: "When enabled, AI does not process the media and a single courtesy message is sent after a short debounce.",
        autoReplyMediaScopeLabel: "When to reply",
        autoReplyMediaScopeAiOnly: "Only when AI should respond",
        autoReplyMediaScopeAlways: "Always (even if a human is handling the ticket)",
        autoReplyMediaTypesLabel: "Behavior per media type",
        autoReplyMediaTypeAudio: "Audio (voice notes and attachments)",
        autoReplyMediaTypeVideo: "Videos",
        autoReplyMediaTypeImage: "Images",
        autoReplyMediaTypeDocument: "Documents",
        autoReplyMediaTextAudio: "Text for audio",
        autoReplyMediaTextVideo: "Text for videos",
        autoReplyMediaTextImage: "Text for images",
        autoReplyMediaTextDocument: "Text for documents",
        autoReplyMediaTypeSticker: "Stickers",
        autoReplyMediaTypeReaction: "Reactions (emojis and 👍)",
        autoReplyMediaTextSticker: "Text for stickers",
        autoReplyMediaTextReaction: "Text for reactions",
        autoReplyMediaActionLabel: "Behavior",
        autoReplyMediaActionAi: "Send to AI",
        autoReplyMediaActionIgnore: "Ignore",
        autoReplyMediaActionReply: "Reply with text",
        autoReplyMediaReactionHelp: "Reactions (👍 ❤️ etc.) are passed to the AI as text. The AI reads them as confirmations or replies.",
        autoReplyMediaTextGeneric: "Generic text (used when several types arrive together)",
        autoReplyMediaTextPlaceholder: "Leave empty to use the company-language default.",
        autoReplyMediaTimeoutLabel: "Debounce (seconds)",
        autoReplyMediaTimeoutHelp: "Time to wait after the last audio/video/image/doc before sending the reply. Suggested: 60.",
        emailReportSectionTitle: "📧 Email reports",
        emailReportSectionDesc: "When a queue stays without a response for the configured time, the system sends a report email to the configured recipient.",
        emailReportQueues: "Trigger queues",
        emailReportQueuesHelp: "The report is sent when a ticket in these queues has been inactive for the configured time.",
        emailReportRecipients: "Report recipients",
        emailReportRecipientsHelp: "Separate with commas. E.g.: admin@company.com, support@company.com",
        emailReportTimeoutHours: "Inactivity hours to send report",
        emailReportTimeoutHelp: "Time without client response before sending the report.",
        emailReportSubjectTemplate: "Email subject",
        emailReportSubjectPlaceholder: "{wlName} - Ticket report - {contactName}",
        emailReportHtmlTemplate: "HTML email template",
        emailReportHtmlHelp: "You can edit the template. The current system template is preloaded.",
        emailReportVarsTitle: "Variables available in subject and template",
        emailReportVarsDesc: "{wlName} brand · {companyName} company · {contactName} contact name · {contactPhone} phone · {queueName} queue · {userName} agent · {ticketId} · {closeReason} reason · {aiSummary} AI summary · {ticketLink} link · {closedAt} date · {wlLogoUrl} logo",
        emailReportTestLabel: "Email for test send",
        emailReportTestBtn: "Send test",
        emailReportTestSending: "Sending...",
        emailReportTestSuccess: "✓ Test email sent to {email}",
        emailReportTestError: "✗ Error: {error}",
        emailReportSuperadminAllowed: "Allow email reports",
        emailReportSuperadminAllowedHelp: "Enables the email report configuration section for the company admin.",
      },
      headerMetrics: {
        resueltos: "Chats closed today by your team",
        atencionEspera: "Chats currently active / waiting for a reply",
        tdr1ra: "Average time from client message to first agent reply today",
        tdrResp: "Average response time per message over the last 30 days",
      },
      appointmentsSettings: {
        titulo: "Appointment Settings",
        empresa: "Company",
        general: "General",
        activarModulo: "Enable appointments module",
        contactarAdmin: "To enable or disable the appointments module, contact the system administrator.",
        canalWhatsapp: "WhatsApp channel for notifications",
        principalAuto: "Primary (automatic)",
        tiposCita: "Appointment types",
        tiposCitaDesc: "The agent selects the type when scheduling. Be specific.",
        cargarEjemplos: "Load examples",
        nuevoTipo: "New type",
        agregar: "Add",
        avisosAutomaticos: "Automatic notifications",
        aviso1: "Notification 1 — 24 hours before",
        aviso2: "Notification 2 — First thing on the day of the appointment",
        aviso3: "Notification 3 — Shortly before the appointment",
        textoMensaje: "Message text",
        minutosAntes: "Minutes before",
        horaAviso: "Notification time",
        notaAviso2: "Note: If the appointment is first thing and notification 3 falls within the next 30 minutes, this notification is automatically skipped.",
        guardarConfig: "Save settings",
        errorGuardar: "Error saving",
        configGuardada: "Settings saved",
      },
      bulkImport: {
        cancelButton: "Cancel",
        cancelConfirmTitle: "Cancel send?",
        cancelConfirmBody: "This send will be permanently stopped. It cannot be resumed.",
        cancelSuccess: "Send cancelled",
        cancelError: "Could not cancel send",
      },
      bulkSend: {
        // feat_210 estándar — Excel modelo + preview por cantidad de variables
        standard: {
          downloadTemplate: "Download Excel template",
          downloadFileName: "bulk-send-template.xlsx",
          byVarCountTitle: "Valid rows depending on the template you choose",
          byVarCount: "With a {{n}}-variable template: {{count}} valid rows",
          byVarCountOne: "With a 1-variable template: {{count}} valid rows",
          noValidAny: "No row works with any template. Check the file.",
          missingRequired: "Required columns are missing from the file: {{columns}}",
          missingForTemplate: "This template uses {{n}} variables and the file is missing: {{columns}}",
          missingInRows: "{{column}} is missing in {{count}} rows",
          ruleDiscarded: "The rule on column {{column}} discarded {{count}} rows",
          checking: "Checking the file with this template…",
          tplValid: "With this template: {{count}} valid rows out of {{total}}",
          tplNoValid: "No valid rows are left with this template.",
          varsExceed: "The template has {{tpl}} variables and the standard file allows up to {{max}}. Choose a template with fewer variables.",
          noSample: "The sample appears once you choose the template.",
        },
        steps: { upload: "File", preview: "Preview", template: "Template", options: "Options", confirm: "Confirm" },
        history: {
          title: "Send history",
          viewHistory: "View send history",
          backToWizard: "Back to wizard",
          backToList: "Back to history",
          columnDate: "Date", columnFile: "File", columnStatus: "Status", columnProgress: "Progress",
          loadMore: "Load more", empty: "No sends have been made yet.",
        },
        back: "Back",
        next: "Next",
        upload: {
          hint: "Drag or click to upload your Excel file (.xlsx)",
          choose: "Choose file",
          selected: "File: {{name}}",
          readError: "Could not read the file",
        },
        preview: {
          total: "Total rows", valid: "Valid", skipped: "Skipped",
          skFilter: "By filter", skPhone: "Invalid phone", skDup: "Duplicates",
          sample: "Sample (first normalized rows)",
          colName: "Name", colPhone: "Phone", colVars: "Variables",
          noValid: "No valid rows to send. Check the file and the profile filters.",
        },
        template: {
          connLabel: "Meta connection", noConn: "No connected Meta connections in this company.",
          tplLabel: "Approved template", noTpl: "This connection has no approved templates.",
          lastUsedHint: "last used",
          varsTitle: "Message preview (with the first row)",
          varMismatch: "The template has {{tpl}} variables but the profile builds {{prof}}. Pick a template with the same count.",
        },
        options: {
          throttle: "Seconds between sends", throttleHelp: "Pause between each message (1 to 60 seconds).",
          contextModeLabel: "Context mode",
          contextModeNormal: "Normal",
          contextModeTurnosia: "TurnosIA (booking invitation)",
          contextModeHint: "How the assistant is told what this send is about. In TurnosIA mode, besides sending the template, the assistant is informed that the contact was invited to book an appointment.",
          optIn: "I confirm the recipients gave their consent to receive messages.",
          overwriteTitle: "Warning: this send overwrites existing data",
          overwrite: "If a recipient already exists as a contact in WAIA, this send will overwrite their notes and reassign the assistant, queue and status defined in this profile. Confirm this is the intended behavior.",
        },
        confirm: {
          title: "Review before sending", file: "File", validRows: "Rows to send",
          conn: "Connection", tpl: "Template", throttle: "Pause between sends",
          warnBrief: "Remember: existing contacts get overwritten (notes, assistant, queue, status).",
          send: "Confirm and send", sentOk: "Send started",
        },
        dedupe: {
          msg: "An identical file was already uploaded on {{date}}. Send anyway?",
          confirm: "Send anyway", cancel: "Cancel",
        },
        result: {
          title: "Send result", pending: "Queued", processing: "Processing",
          completed: "Completed", pausedMeta: "Paused (Meta)", failed: "Failed", cancelled: "Cancelled",
          sent: "Sent", failedC: "Failed", skipped: "Skipped", total: "Total",
          pausedExplain: "The send was paused because Meta rejected 5 messages in a row. Check the connection and retry the failed ones.",
          retry: "Retry failed", retrying: "Retrying...", retryDone: "{{n}} rows re-queued",
          newImport: "New send", rowsTitle: "Per-row detail", colStatus: "Status", colDetail: "Detail",
          rowStatus: {
            pending: "Queued", sent: "Sent", failed: "Failed",
            skipped_filter: "Skipped (filter)", skipped_invalid_phone: "Invalid phone",
            skipped_dup_in_batch: "Duplicate", skipped_optout: "No consent",
          },
        },
      },
      cargaDeDatos: {
        menuTitle: "Data Upload",
        empty: "No forms configured",
        loading: "Loading...",
        errorLoading: "Error loading the form",
      },
      metaTemplates: {
        drawerTitle: "Meta Templates",
        tabMine: "My templates",
        tabSend: "Send template",
        syncButton: "Sync",
        syncSuccess: "{{count}} templates synced",
        syncError: "Error syncing templates",
        newButton: "New template",
        noTemplates: "No templates. Click Sync to load from Meta.",
        deleteConfirm: "Delete this template in Meta and the system?",
        deleteSuccess: "Template deleted",
        deleteError: "Error deleting template",
        createSuccess: "Template submitted to Meta for approval",
        createError: "Error creating template",
        sendSuccess: "Template sent",
        sendError: "Error sending template",
        form: {
          name: "Name (snake_case, no spaces)",
          category: "Category",
          language: "Language",
          headerType: "Header (optional)",
          headerFormat: "Header type",
          headerFormats: {
            NONE: "None",
            TEXT: "Text",
            IMAGE: "Image",
            DOCUMENT: "Document",
            VIDEO: "Video",
          },
          headerSample: "Sample file",
          headerSampleNotice:
            "This file is only an example so Meta can approve the template. On every send you will pick the real file (the invoice, the quote, etc.).",
          headerSampleChoose: "Choose sample file",
          pendingNotice:
            "The template stays pending until Meta approves it. Approval may take a while; the status updates when you sync.",
          headerText: "Header text",
          body: "Message body",
          bodyHint: "Use {{1}}, {{2}}, etc. for variables",
          examplesHint: "Meta requires one example per variable to approve the template.",
          exampleFor: "Example for {{var}}",
          varsNotSequential: "Variables must be sequential starting at {{1}} (no gaps).",
          footer: "Footer (optional)",
          submit: "Create template",
          cancel: "Cancel",
        },
        suggested: {
          useButton: "Use a suggested template",
          listTitle: "Suggested templates (ready for approval)",
          approvalNotice:
            "These templates go through Meta approval, but being pre-validated they are usually approved quickly. You can edit the text and examples before creating it.",
          names: {
            retomar_conversacion: "Resume conversation",
            recordatorio_cita: "Appointment reminder",
            seguimiento_general: "Follow-up",
            aviso_disponible: "Updates notice",
            reapertura_24h: "Reopen after 24h",
          },
        },
        categories: {
          MARKETING: "Marketing",
          UTILITY: "Utility",
          AUTHENTICATION: "Authentication",
        },
        languages: {
          es: "Spanish",
          en: "English",
          pt: "Portuguese",
          it: "Italian",
        },
        status: {
          APPROVED: "Approved",
          PENDING: "Pending",
          REJECTED: "Rejected",
          PAUSED: "Paused",
          DELETED: "Deleted",
          DISABLED: "Disabled",
          IN_APPEAL: "In appeal",
          REINSTATED: "Reinstated",
          LIMIT_EXCEEDED: "Limit exceeded",
          PENDING_DELETION: "Pending deletion",
        },
        sendForm: {
          pausedManualNotice: "This line is paused for automatic sends. This manual send will go out.",
          attachment: "Attachment",
          attachmentChoose: "Choose file",
          attachmentHint: {
            DOCUMENT: "This template sends a document: pick the real file (PDF, Word or Excel).",
            IMAGE: "This template sends an image: pick the real file.",
            VIDEO: "This template sends a video: pick the real file.",
          },
          selectTemplate: "Select an approved template",
          toNumber: "Destination number (with country code)",
          variables: "Variable {{index}}",
          submit: "Send",
          noApproved: "No approved templates",
        },
        windowBanner: {
          message: "⏰ 24h window closed. The contact must write first, or start the conversation with a template.",
          sendTemplate: "Send template",
        },
        inline: {
          selectLabel: "Choose a template",
          noApproved: "You don't have approved templates yet. Create one to start the conversation.",
          createButton: "Create template",
          previewLabel: "Preview",
          sendButton: "Send template",
          sentTitle: "Template sent",
          sendAnother: "Send another",
        },
      },
      embeddedSignup: {
        title: "Connect WhatsApp Business",
        connectButton: "Connect with Meta",
        manualButton: "Enter data manually",
        connecting: "Connecting...",
        success: "Connection created successfully",
        error: "Error connecting with Meta",
        connectionName: "Connection name",
        emptyMetaError: "Complete the connection with Meta (Connect with Meta button) or enter the data manually. An empty Meta connection cannot be created.",
        cancelled: "Meta connection cancelled.",
      },
      batchSelection: {
        exit: "Exit selection",
        count: "{{count}} selected",
        markRead: "Mark as read",
        resolve: "Resolve",
        transfer: "Transfer",
        delete: "Delete",
        restore: "Restore",
        hardDelete: "Delete permanently",
        more: "More actions",
        selectAllVisible: "Select all visible",
        toast: {
          markReadOk: "{{count}} chats marked as read",
          markReadPartial: "Marked as read {{processed}} of {{total}} ({{skipped}} skipped)",
          resolveOk: "{{count}} chats resolved",
          resolvePartial: "Resolved {{processed}} of {{total}} ({{skipped}} skipped)",
          transferOk: "{{count}} chats transferred",
          transferPartial: "Transferred {{processed}} of {{total}} ({{skipped}} skipped)",
          restoreOk: "{{count}} chats restored",
          restorePartial: "Restored {{processed}} of {{total}} ({{skipped}} skipped)",
          deletedWithUndo: "{{count}} chats moved to Deleted",
          undo: "Undo",
          undoOk: "Restore applied",
          hardDeleteOk: "{{count}} chats permanently deleted",
          hardDeletePartial: "Permanently deleted {{processed}} of {{total}} ({{skipped}} skipped)",
        },
      },
      resolveTicketDialog: {
        title: "How did this conversation end?",
        batchCount: "You are about to resolve {{count}} chats.",
        won: "Won",
        lost: "Lost",
        noChange: "No change — resolve anyway",
      },
      batchTransferDialog: {
        title: "Transfer chats",
        subtitle: "You are about to transfer {{count}} chats to a queue.",
        queueLabel: "Destination queue",
        queuePlaceholder: "Select queue...",
        cancel: "Cancel",
        confirm: "Transfer",
      },
      batchDeleteDialog: {
        title: "Delete chats",
        body: "You are about to delete {{count}} chats. You can restore them from Deleted.",
        cancel: "Cancel",
        confirm: "Delete",
      },
      batchHardDeleteDialog: {
        title: "Delete permanently",
        body: "This will permanently delete {{count}} chats. This cannot be undone.",
        bodySingle: "This will permanently delete this chat. This cannot be undone.",
        cancel: "Cancel",
        confirm: "Delete permanently",
      },
      quotedMessage: {
        sticker: "Sticker",
        image: "Image",
        video: "Video",
        audio: "Voice message",
        document: "Document",
        vcard: "Contact",
        location: "Location",
        attachment: "Attachment",
      },
      mediaPlaceholder: {
        sticker: "Sticker",
        image: "Image",
        video: "Video",
        audio: "Voice message",
        document: "Document",
        attachment: "Attachment",
      },
      documentPreview: {
        download: "Download",
        openInNew: "Open in new tab",
        previewFailed: "Preview could not be loaded",
      },
      ticketPresence: {
        composing: "Typing...",
        recording: "Recording audio...",
        composingNamed: "{{name}} is typing...",
        recordingNamed: "{{name}} is recording audio...",
        composingSomeone: "Someone is typing...",
        recordingSomeone: "Someone is recording audio...",
      },
      ticketAttending: {
        header: "Attended by {{name}}",
        // feat_340: sin uso — el zócalo ahora muestra solo el primer nombre del asesor.
        chip: "Handled by {{name}}",
        locked: "Attended by {{name}} — you can't write",
        someone: "another advisor",
      },
      cartAbandonedSchedule: {
        modeLabel: "When to send the abandoned cart notice?",
        always: "Always (no time restriction)",
        businessHours: "Only during the company's business hours",
        custom: "Custom schedule for carts",
        helperAlways: "The notice is sent at any time inactivity is detected.",
        helperBusinessHours: "If the company is outside business hours when abandonment is detected, the notice is automatically deferred to the next run within business hours.",
        helperCustom: "Define your own schedule for abandoned cart notices, independent of business hours.",
        customScheduleLabel: "Custom schedule for abandoned cart notices",
        warningNoBusinessHours: "⚠ You have no business hours configured. The abandoned cart notice will not be sent until you set them up in the Business hours section.",
        goToBusinessHours: "Go to Business hours",
      },
      welcomeNotice: {
        sectionTitle: "One-time welcome message",
        sectionHelp: "For a message the AI should say only once per contact (for example: «We're launching a new system and registering each customer just once»).",
        enabledLabel: "Remember who already got it",
        enabledHelp: "The AI receives whether the contact already saw it and whether they are a known customer.",
        enabledTooltip: "With this on, every message that reaches the AI says whether the contact already received the welcome message and whether they are already a registered customer. The AI must be set up not to repeat it. The contact is marked when the AI sends it (if it matches the phrases below) or when the AI reports it was shown. An admin can clear the mark from the contact card.",
        matchLabel: "Phrases that identify the message",
        matchPlaceholder: "new system|registering each customer",
        matchHelp: "Separated by «|». When the AI sends a message containing one of them, the contact is marked. Case and accents don't matter. Empty = only the AI marks it.",
        blockLabel: "AI doesn't write if the chat already has an agent",
        blockHelp: "If an agent took the chat, an AI reply arriving afterwards is not sent.",
        blockTooltip: "Prevents the AI from replying seconds after an agent already answered (the AI reply was already on its way). With this on, if the chat has an assigned agent and is not closed, the AI reply is dropped and never reaches the customer.",
        contactTitle: "Welcome message",
        contactSent: "Received on {{date}}",
        contactNotSent: "Not received yet",
        resetButton: "Show again",
        resetConfirmTitle: "Show the welcome message again?",
        resetConfirmBody: "The AI will be able to say the welcome message to this contact again on their next greeting.",
        resetDone: "Done, the contact will get the welcome message again.",
      },
      holidays: {
        title: "Holidays",
        nationals: "National holidays",
        nationalsHelp: "Turn the switch on if your business works that holiday.",
        customs: "Custom holidays",
        noCustoms: "No custom holidays yet.",
        works: "We work",
        closed: "Closed",
        recurring: "yearly",
        addCustom: "Add custom holiday",
        confirmDelete: "Delete this holiday?",
        dateLabel: "Date",
        nameLabel: "Name",
        recurringLabel: "Repeats every year",
        recurringHelp: "",
        cancel: "Cancel",
        save: "Save",
        saveOk: "Holiday saved",
        nameHelp: "The reason the customer will see. E.g.: Founders' Day.",
        scopeLabel: "Scope (optional)",
        scopeHelp: "Where it applies. E.g.: “Córdoba only”. Empty = general.",
        messageLabel: "Message for the customer (optional)",
        messageHelp: "Replaces the general message for this day. You can use {motivo}, {fecha_reapertura} and {alcance}.",
        edit: "Edit",
        delete: "Delete",
        editTitle: "Edit holiday",
        editNote: "Scope and message",
        nationalNoteHelp: "This national holiday still closes the company. Here you can add its scope and a custom message for the customer.",
        hasMessage: "Has a custom message",
        noticeTitle: "Holiday notice to customers",
        noticeDescription: "Whoever writes on WhatsApp learns which day is a holiday, why, and when service resumes.",
        noticeEnabledLabel: "Tell customers about holidays",
        noticeEnabledHelp: "The AI receives the holidays; without AI, WAIA replies with a notice.",
        noticeEnabledTooltip: "When on: if the company has an AI, it receives the holidays of the next 30 days (reason, scope and when service resumes) to tell the customer when they ask about those days or delivery times. If no AI will reply (no AI, AI off or an agent in charge), on the holiday WAIA automatically replies with the message below, once per contact per day. Never to groups.",
        noticeTemplateLabel: "Holiday message",
        noticeTemplateHelp: "Empty = default message. Variables: {motivo}, {fecha_reapertura}, {alcance}.",
        noticeDefault: "Hi 👋 We are closed today for {motivo}. We resume on {fecha_reapertura}. We'll reply as soon as we're back.",
        upcomingTitle: "Upcoming holidays (30 days)",
        upcomingHelp: "This is what the AI receives and what the automatic notice uses.",
        upcomingNone: "No holidays in the next 30 days.",
        today: "Today",
        reopens: "resumes on {{when}}",
        refresh: "Refresh",
        sampleLabel: "This is how the notice would look on {{date}}:",
      },
      weeklySchedule: {
        addRange: "Add time range",
        removeRange: "Remove range",
        to: "to",
        days: {
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday",
        },
      },
      emailReportTimerMode: {
        label: "When to start counting time for the report?",
        updatedAt: "From the last message sent or received",
        updatedAtHelp: "The timer resets every time there is a new message in the ticket, including automatic AI responses.",
        createdAt: "From the start of the conversation (T0)",
        createdAtHelp: "The counter does not reset with automatic activity. The email always arrives {{hours}}h after the first message, regardless of whether the AI tried to recover the customer.",
      },
      metaErrorCodes: {
        "-100": "Not sent: sending on this connection was paused.",
        tooltipPrefix: "Delivery failed",
        131042: "Missing payment method in Meta (Billing Center).",
        131047: "24-hour window closed — an approved template is required.",
        131026: "The number doesn't have WhatsApp or the message couldn't be delivered.",
        131051: "Message type not supported by Meta.",
        132000: "The template doesn't match the sent variables.",
        132001: "The template doesn't exist or was deleted.",
        132005: "The template is paused by Meta.",
        132007: "The template was disabled by Meta.",
        132012: "Invalid template variable format.",
        133010: "The number is not registered on WhatsApp Cloud API.",
        default: "Meta delivery error (code {{code}}).",
        default_unknown: "Meta delivery error.",
      },
      // feat_299 — "View as user". Own namespace: do NOT reuse `impersonate`
      // (superadmin panel), it is a different feature.
      viewAs: {
        menuLabel: "View as user",
        modalTitle: "View as user",
        searchPlaceholder: "Search user...",
        cancel: "Cancel",
        noUsers: "No users available",
        banner: "Viewing as {{name}}",
        exit: "Exit",
        activated: "Now viewing as {{name}}",
      },
      // feat_316 — per-user notification preferences
      notificationPrefs: {
        title: "Notifications",
        active: "Enabled",
        mutedPermanent: "Muted",
        snoozedUntil: "Muted until {{time}}",
        snoozeFor: "Mute for:",
        untilOpening: "Until we open",
        mutePermanent: "Mute until I turn it back on",
        sound: "Sound",
        browser: "Browser notification",
        browserBlocked: "The browser blocked notifications. Enable them from the padlock in the address bar.",
        browserDenied: "Permission was not granted. You can enable it from the padlock in the address bar.",
        badgeNote: "Muting affects the sound and the browser alert. The counter and the chat list keep updating.",
      },
      contactPriority: {
        label: "Notification priority",
        normal: "Normal",
        priority: "Priority (always notifies)",
        muted: "Muted (never notifies)",
        help: "\"Priority\" notifies even when your notifications are muted. \"Muted\" never notifies.",
      },
      // feat_333 — WAIAenvios mode (superadmin panel switch label)
      waiaEnvios: {
        switchLabel: "WAIAenvios — template campaigns only",
        switchHelp: "Leaves the panel with Connections and Data Upload only. The client replies from their own phone.",
      },
      // Module boundary (feat_364). If TurnosIA fails, only TurnosIA fails.
      errorBoundary: {
        routeTitle: "This screen could not be displayed",
        routeHelp: "Try another section from the menu, or reload the page.",
        moduleTitle: "This section is not available right now",
        moduleHelp: "The rest of WAIA keeps working normally. If it happens again, let support know.",
        appTitle: "Something went wrong",
        appHelp: "Reload the page to continue.",
        inline: "This part could not be displayed.",
        retry: "Try again",
        reload: "Reload the page",
      },
    },
  },
};

export { messages };
